const frLocale = {
  test: `Tester les paramètres régionaux`,
  dashboard: `Tableau de bord`,
  engage: `S'engager`,
  assets: `Actifs`,
  submissions: `Soumissions`,
  impact: `Impact`,
  programmes: `Programmes`,
  interactions: `Interactions`,
  donations: `Dons`,
  impact_strategy: `Stratégie d'impact`,
  my_profile: `Mon profil`,
  organisation: `Organisation`,
  users: `Utilisateurs`,
  profile: `Profil`,
  help: `Aide`,
  logout: `Déconnexion`,
  insights: `Connaissances`,
  data: `Données`,
  progress: `Progrès`,
  ideas: `Idées`,
  reviewed: `Révisé`,
  in_progress: `En cours`,
  pending_review: `En attente d'examen`,
  most_popular_theme: `Thème le plus populaire`,
  local_resident: `Résident local`,
  local_business: `Entreprise locale`,
  charitable_group: `Groupe caritatif`,
  other_stakeholder: `Autre partie prenante`,
  cultural: `Culturel`,
  environmental: `Environnemental`,
  economic: `Économique`,
  educational: `Pédagogique`,
  social: `Sociale`,
  responder_types: `Types de répondeurs`,
  most_popular_category: `Catégorie la plus populaire`,
  green_spaces: `Espaces verts`,
  local_tourism: `Tourisme local`,
  skills_development: `Développement des compétences`,
  other: `Autre`,
  most_popular_sub_category: `Sous-catégorie la plus populaire`,
  grassland: `Prairie`,
  burgers: `Des hamburgers`,
  green_skills: `Compétences vertes`,
  filters: `Filtres`,
  theme: `Thème`,
  category: `Catégorie`,
  sub_category: `Sous-catégorie`,
  ideas_by_phase: `Idées par phase`,
  oops: `Oups ! Le nom d'utilisateur/mot de passe est peut-être incorrect`,
  forgot_password: `Mot de passe oublié ?`,
  forgot_password_line1: `Si vous avez un compte, vous aurez reçu un e-mail « Réinitialiser le mot de passe » du support BizGive. Suivez le lien contenu dans cet e-mail pour créer un nouveau mot de passe.`,
  forgot_password_line2: `Veuillez également vérifier votre dossier spam.`,
  forgot_password_line3: `Si vous ne recevez pas d'e-mail, vous n'avez peut-être pas de compte actif. Veuillez contacter le support BizGive.`,
  forgot_password_header: `Veuillez vérifier votre boîte de réception`,
  incorrect_email_id: `Veuillez vérifier l'identifiant de messagerie que vous avez saisi.`,
  forget_password: `Mot de passe oublié`,
  forget_password_hint: `Veuillez utiliser plus de 8 caractères, une lettre majuscule et minuscule, un chiffre et un caractère spécial.`,
  date_submitted: `Date de soumission`,
  feedback_type: `Type de commentaires`,
  need: `Besoin`,
  attributes: `Attributs`,
  happy_to_be_contacted: `Heureux d'être contacté?`,
  contact_information: `Coordonnées`,
  the_sender_has_multiple_submissions: `L'expéditeur a plusieurs soumissions.`,
  actions: `Actes`,
  add_comment: `Ajouter un commentaire`,
  date_actioned: `Date d'action`,
  actioned_by: `Actionné par`,
  back_to_map: `Retour à la carte`,
  submitter_type: `Type de demandeur`,
  submitter_location: `Emplacement de l'expéditeur`,
  submission_location: `Lieu de soumission`,
  categories: `Catégories`,
  yes: `Oui`,
  no: `Non`,
  save: `Sauvegarder`,
  idea_location: `Emplacement de l'idée`,
  please_populate: `Veuillez remplir`,
  comments_added_successfully: `Commentaires ajoutés avec succès`,
  see_location: `Voir l'emplacement`,
  feedback: `Retour`,
  feedback_by_phase: `Commentaires par phase`,
  feedback_location: `Emplacement des commentaires`,
  comment: `Commentaire`,
  asset: `Actif`,
  phase: `Phase`,
  idea: `Idée`,
  submitter: `Auteur`,
  requestedContact: `Contact demandé ?`,
  collaborate: `Collaborer`,
  contact_by_phase: `Contact par phase`,
  collaborate_location: `Collaborer Emplacement`,
  number_of_employees: `Nombre d'employés`,
  global_annual_turnover: `Chiffre d’affaires annuel mondial (en millions de livres sterling)`,
  industry: `Industrie`,
  services_provided: `Services fournis`,
  services_description: `Description des services`,
  renewable_experience: `Expérience renouvelable ?`,
  requested_introduction_to_tier_one_contractors: `Vous avez demandé une introduction aux entrepreneurs de niveau 1 ?`,
  organization_name: `Nom de l'organisation`,
  website: `Site web`,
  overview: `Aperçu`,
  all_projects: `Tous les projets`,
  total_visitors: `Nombre total de visiteurs`,
  feedback_submitted: `Commentaires soumis`,
  ideas_submitted: `Idées soumises`,
  collaborations_submitted: `Collaborations soumises`,
  pending_actions: `Actions en attente`,
  three_month_historical_visitors: `Visiteurs historiques de 3 mois`,
  submission_type: `Type de soumission`,
  collaborations: `Collaborations`,
  applications: `Applications`,
  action_required: `Action requise`,
  pending_response: `En attente de réponse`,
  pre_approved: `Pré-approuvé`,
  approved: `Approuvé`,
  declined: `Refusé`,
  your_session_will_expire_in: `Votre session expirera dans…`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Choisissez si vous souhaitez rester connecté ou vous déconnecter. Si vous ne faites rien, vous serez automatiquement déconnecté pour des raisons de sécurité.`,
  stay_logged_in: `Restez connecté`,
  log_out: `Se déconnecter`,
  all_phases: `Toutes les phases`,
  login: `Se connecter`,
  not_registered_yet: `Pas encore inscrit ?`,
  sign_up: `S'inscrire`,
  user_terms: `Conditions d'utilisation`,
  privacy_policy: `politique de confidentialité`,
  create_an_account_to_apply_for_support: `Créez un compte pour demander de l'aide`,
  are_you_impact_funder_contact_us: `Êtes-vous un bailleur de fonds à impact ? Contactez-nous`,
  confirm_password: `Confirmez le mot de passe`,
  password_must_include: `Le mot de passe doit inclure :`,
  more_than_eight_characters: `- Plus de 8 caractères`,
  an_upper_and_lower_case_character: `- Un caractère majuscule et minuscule`,
  a_number: `- Un numéro`,
  a_special_character: `- Un personnage spécial`,
  i_accept_the: `J'accepte le`,
  register: `Registre`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Connectez-vous avec les bailleurs de fonds et concevez vos opportunités pour créer un impact positif`,
  or_login_to_create_your_free_BizGive_account: `ou connectez-vous pour créer votre compte BizGive gratuit.`,
  discover: `Découvrir`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `programmes de financement et créez un profil pour recevoir des alertes.`,
  submit: `Soumettre`,
  applications_auto_verified_against_funder_criteria: `candidatures, automatiquement vérifiées par rapport aux critères des bailleurs de fonds.`,
  share: `Partager`,
  content_track_impact_and_capture_funder_feedback: `contenu, suivre l’impact et recueillir les commentaires des bailleurs de fonds.`,
  here: `ici`,
  please_enter_password: `Veuillez entrer le mot de passe`,
  ok: `D'accord`,
  confirm_email: `Confirmez votre email`,
  log_in: `Se connecter`,
  please_enter_email: `Veuillez entrer votre e-mail`,
  the_input_is_not_valid_email: `L'entrée n'est pas valide E-mail !`,
  the_new_password_that_you_entered_do_not_match: `Le nouveau mot de passe que vous avez saisi ne correspond pas !`,
  the_new_email_that_you_entered_do_not_match: `Le nouvel email que vous avez saisi ne correspond pas !`,
  please_confirm_your_password: `Veuillez entrer Confirmer le mot de passe`,
  please_accept_the_user_terms: `Veuillez accepter les conditions d'utilisation`,
  change_password: `Changer le mot de passe`,
  password: `Mot de passe`,
  we_just_emailed: `Nous venons d'envoyer un e-mail`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Veuillez cliquer sur le lien dans votre email pour activer votre compte`,
  please_enter_a_valid_password: `Veuillez entrer un mot de passe valide`,
  you_have_been_logged_out_due_to_inactivity: `Vous avez été déconnecté pour cause d'inactivité...`,
  please_enter_a_valid_password_using_the_guidance_below: `Erreur - Veuillez saisir un mot de passe valide en suivant les instructions ci-dessous.`,
  entity: `Entité`,
  unique_visitors: `Visiteurs uniques`,
  questions: `Questions`,
  localQuestions: `Questions locales`,
  visitors: `Visiteurs`,
  visitor_id: `ID visiteur`,
  answer: `Répondre`,
  question_time: `Heure des questions`,
  avg_question_per_visitor: `Moy. Question par visiteur`,
  media: `Médias`,
  logo: `Logo`,
  profile_create: `Créer un profil`,
  lets_get_started: `Commençons`,
  name_and_location: `Nom et emplacement`,
  what_is_the_legal_Name_of_your_entity: `Quelle est la dénomination sociale de votre entité ?`,
  what_entity_name_would_like_to_be_displayed: `Quel nom d'entité souhaite être affiché ?`,
  what_is_your_registered_address: `Quelle est votre adresse enregistrée ?`,
  description: `Description`,
  add_your_description: `Ajoutez votre description`,
  add_your_social_media_details: `Ajoutez vos détails sur les réseaux sociaux`,
  what_is_your_website: `Quel est votre site internet ?`,
  optional: `Facultatif`,
  add_your_company_logo: `Ajoutez le logo de votre entreprise`,
  upload: `Télécharger`,
  organization_profile: `Profil de l'organisation`,
  description_company: `Description`,
  detail: `Détail`,
  registered_address: `Adresse enregistrée`,
  proceed: `Procéder`,
  previous: `Précédent`,
  save_n_exit: `Enregistrer et quitter`,
  next: `Suivant`,
  enter: `Entrer`,
  complete: `Complet`,
  my_details: `Mes coordonnées`,
  your_name: `Votre nom`,
  phone_number: `Numéro de téléphone`,
  job_title: `Titre d'emploi`,
  biz_give_role: `Rôle BizGive`,
  member_since: `Membre depuis`,
  my_programmes: `Mes programmes`,
  delete_file_confirmation: `Confirmation de suppression du fichier`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Veuillez confirmer que vous acceptez de supprimer définitivement ce fichier ?`,
  delete: `Supprimer`,
  cancel: `Annuler`,
  create_password: `Créer un mot de passe`,
  invite_new_user: `Inviter un nouvel utilisateur`,
  regular_users: `Utilisateurs réguliers`,
  can_not_view_or_edit_anything_by_default: `ne peut rien afficher ou modifier par défaut. Tous les utilisateurs invités commencent avec ce statut. Vous pouvez les ajouter aux programmes pour afficher et/ou modifier ce programme spécifique et le contenu associé.`,
  organization_admins: `Administrateurs de l'organisation`,
  can_access_and_edit_everything_in_the_platform: `peut accéder et modifier tout ce qui se trouve sur la plateforme. Vous pouvez attribuer ce privilège aux utilisateurs existants sur cet écran.`,
  user_name: `Nom d'utilisateur`,
  make_admin: `Faire administrateur`,
  remove_admin: `Supprimer l'administrateur`,
  invited: `INVITÉ`,
  regular: `RÉGULIER`,
  admin: `ADMINISTRATEUR`,
  remove_user_from_your_organization: `Supprimer un utilisateur de votre organisation`,
  please_confirm_you_are_to_permanently_remove_this_user: `Veuillez confirmer que vous souhaitez supprimer définitivement cet utilisateur ?`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Aucun de leurs programmes ou données d'interaction ne sera supprimé`,
  remove_user: `Supprimer un utilisateur`,
  remove_admin_rights: `Supprimer les droits d'administrateur`,
  remove: `Retirer`,
  as_an_Organization_Admin: `en tant qu'administrateur de l'organisation.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `Ils ne pourront alors visualiser et modifier que les programmes qu’ils gèrent.`,
  enter_email_address: `Entrez l'adresse e-mail`,
  confirm_email_address: `Confirmez votre adresse email`,
  invite: `Inviter`,
  add_admin_rights: `Ajouter des droits d'administrateur`,
  make: `Faire`,
  an_organization_admin: `un administrateur d'organisation`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `Ils pourront voir et modifier tout ce qui se passe dans votre organisation.`,
  charity_can_not_view_or_edit_anything_by_default: `ne peut rien afficher ou modifier par défaut. Tous les utilisateurs invités commencent avec ce statut. Vous pouvez les ajouter aux applications pour afficher et/ou modifier cette application spécifique et le contenu associé.`,
  charity_can_access_and_edit_everything_in_the_platform: `peut accéder et modifier tout ce qui se trouve sur la plateforme. Vous pouvez attribuer ce privilège aux utilisateurs existants sur cet écran.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Aucune de leurs applications ou données d'interaction ne sera supprimée`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `Ils ne pourront alors visualiser et modifier que les applications qu’ils gèrent.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `L'utilisateur invité possède déjà un compte lié à cette adresse email. Veuillez vérifier votre liste d'utilisateurs ou contacter BizGive pour obtenir de l'aide.`,
  all_programmes: `Tous les programmes`,
  download: `Télécharger`,
  search_placeholder: `Recherche...`,
  actions_required: `Actions requises`,
  opportunity: `Opportunité`,
  date_applied: `Date d'application`,
  date_requested: `Date demandée`,
  net_vote: `Vote net (électeurs)`,
  date_approved: `Date d'approbation`,
  date_declined: `Date de refus`,
  applied: `APPLIQUÉ`,
  in_edit: `EN EDITION`,
  pre_approved_caps: `PRÉ-APPROUVÉ`,
  approved_caps: `APPROUVÉ`,
  declined_caps: `REFUSÉ`,
  review: `Revoir`,
  customize_your_download: `Personnalisez votre téléchargement`,
  select_application_status: `Sélectionnez le statut de la demande`,
  share_and_manage_voting: `Partager et gérer le vote`,
  current_share_access_closing_date: `Date de clôture actuelle de l’accès au partage`,
  invited_users_will_receive_an_email_with_access_details: `Les utilisateurs invités recevront un e-mail avec les détails d'accès, accessibles jusqu'à la date de clôture. Ils pourront uniquement consulter leurs votes.`,
  invited_voters: `Électeurs invités`,
  add_email_address: `Ajouter une adresse e-mail`,
  reported_grants: `Subventions déclarées`,
  planned_grants: `Subventions prévues`,
  remaining_budget: `Budget restant`,
  total_budget: `Budget total`,
  do_you_wish_to_request_indicators: `Vous souhaitez demander des indicateurs ?`,
  the_entity_will_be_asked_to_create: `Il sera demandé à l'entité de créer des indicateurs pour son opportunité alignés sur les résultats sélectionnés.`,
  please_confirm_you_wish_to_complete_this_item: `Cette étape est terminée.`,
  requested: `Demandé`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `Souhaitez-vous que le candidat crée des indicateurs pour mesurer ses progrès ?`,
  volunteering: `Volontariat`,
  day: `Jour`,
  inkind: `En nature`,
  budget_period_end: `Fin de la période budgétaire`,
  budget_available: `Budget disponible`,
  budget_amount: `Montant budgétaire`,
  remaining: `Restant`,
  select_filter: `Veuillez sélectionner un filtre`,
  donation_title: `Donation`,
  email_id_title: `Identifiant de courrier électronique`,
  add_user: `Ajouter un utilisateur`,
  delete_title: `Supprimer`,
  add_title: `Ajouter`,
  delete_user: `Supprimer un utilisateur`,
  action_cannot_undone: `Cette action ne peut pas être annulée. Toutes les opportunités qu'ils gèrent seront toujours accessibles aux administrateurs de compte.`,
  confirm_title: `Confirmer`,
  adding_admin_rights: `L'ajout de droits d'administrateur donne à l'utilisateur la possibilité de créer des opportunités, de mettre à jour le profil de l'organisation, d'ajouter et de supprimer des utilisateurs et de créer des administrateurs.`,
  remove_admin_rights_para: `La suppression des droits d'administrateur supprime la possibilité pour l'utilisateur de créer des opportunités, de mettre à jour le profil de l'organisation, d'ajouter et de supprimer des utilisateurs et de créer des administrateurs.`,
  save_private: `Enregistré (privé)`,
  planned_shared: `Planifié (partagé)`,
  invoice_requested: `Facture demandée`,
  invoice_received: `Facture reçue`,
  reported_title: `Signalé`,
  confirmed_title: `Confirmé`,
  report_donation: `Signaler un don`,
  cancel_title: `Annuler`,
  save_title: `Sauvegarder`,
  grant: `Accorder`,
  awarded: `Récompensé`,
  award_title: `Prix`,
  type_title: `Taper`,
  invoice_title: `Facture`,
  condition_title: `Condition`,
  reported_date_title: `Date de rapport`,
  next_action_title: `Action suivante`,
  donation_created: `Succès - don créé`,
  donation_updated: `Succès - don mis à jour`,
  donation_deleted: `Succès - don supprimé`,
  view_donation: `Voir le don`,
  select_title: `Sélectionner`,
  approved_opportunities_planned_impact: `Opportunités approuvées (impact prévu)`,
  achieved_impact: `Impact obtenu (opportunités réalisées)`,
  achieved_beneficiaries: `Bénéficiaires atteints`,
  outputs_achieved: `Produits obtenus`,
  content_received: `Contenu reçu (impact obtenu)`,
  opportunity_name: `Nom de l'opportunité`,
  entity_name: `Nom de l'entité`,
  due_date: `Date d'échéance`,
  number: `Nombre`,
  approved_date: `Date d'approbation`,
  view: `Voir`,
  primary_UN_SDG: `ODD primaire de l’ONU `,
  opportunity_type: `Type d'opportunité`,
  charity_name: `Nom de l'organisme de bienfaisance`,
  select_type: `Veuillez sélectionner un type`,
  please_fill_amount: `Veuillez indiquer le montant`,
  enter_title: `Entrer`,
  please_enter_conditions: `veuillez entrer la condition`,
  please_select_action: `Veuillez sélectionner une action`,
  actions_title: `Actes`,
  select_action: `Sélectionnez une action`,
  payment_reference: `Référence de paiement`,
  please_select_amount: `Veuillez sélectionner un montant`,
  enter_payment_reference: `Saisir la référence du paiement`,
  upload_counterpart_behalf: `Télécharger la facture au nom de la contrepartie`,
  equivalent_value: `Valeur équivalente`,
  amount_title: `Montant`,
  purchase_order: `Bon de commande`,
  files_title: `Fichiers`,
  company_name_title: `Nom de l'entreprise`,
  programme_type_title: `Type de programme`,
  application_start_date: `Date de début de la candidature`,
  application_end_date: `Date de fin de candidature`,
  location_title: `Emplacement`,
  next_update_outcome: `Prochaine mise à jour/résultat`,
  donations_by: `Dons par`,
  decision_date: `Date de la décision`,
  decision_start_date: `Date de début de la décision`,
  decision_end_date: `Date de fin de la décision`,
  opportunity_i_manage: `Opportunités que je gère`,
  select_template: `Sélectionnez un modèle`,
  please_select_template: `Veuillez sélectionner un modèle`,
  save_draft: `Enregistrer le brouillon`,
  all_opportunities: `Toutes les opportunités`,
  excel_title: `Exceller`,
  budget_period: `Période budgétaire`,
  latest_period: `Dernière période`,
  select_donation_status: `Sélectionnez le statut du don`,
  delete_file: `Supprimer le fichier`,
  deleting_file_para: `La suppression de ce fichier le supprimera définitivement`,
  delete_donation: `Supprimer le don`,
  delete_donation_para: `La suppression de ce don supprimera définitivement toutes les informations associées.`,
  cancel_changes: `Annuler les modifications`,
  remove_title: `Retirer`,
  will_remove_changes_to_donation: `Cela supprimera toutes les modifications apportées au don`,
  edit_title_uppercase: `MODIFIER`,
  current_report_period: `Période actuelle du rapport`,
  current_report_open: `Rapport actuel ouvert`,
  current_report_close: `Clôture du rapport actuel`,
  manage_title: `Gérer`,
  open_date: `Date d'ouverture`,
  close_date: `Date de clôture`,
  period_title: `Période`,
  reporter_title: `Journaliste`,
  edit_title: `Modifier`,
  about_me: `Sur moi`,
  please_enter_valid_name: `Veuillez entrer un nom valide`,
  please_enter_only_alphabets: `Veuillez saisir uniquement des alphabets`,
  name_Title: `Nom`,
  phone_number_title: `Numéro de téléphone`,
  upload_purchase_order: `Télécharger le bon de commande`,
  programme_dates: `Dates du programme`,
  programme_start: `Début du programme`,
  programme_end: `Fin du programme`,
  currency: `Devise`,
  current_budget_year_end: `Fin de l’année budgétaire en cours :`,
  approved_summary: `Résumé approuvé`,
  please_select_programme: `Veuillez sélectionner un programme`,
  generate: `Générer`,
  opportunities_supported: `Opportunités prises en charge`,
  approved_opportunities: `Opportunités approuvées`,
  planned_impact: `Impact prévu (opportunités approuvées)`,
  grants: `Subventions`,
  planned_beneficiaries: `Bénéficiaires prévus`,
  direct: `Direct`,
  indirect: `Indirect`,
  primary: `Primaire`,
  secondary: `Secondaire`,
  all: `Tous`,
  programme_name: `Nom du programme`,
  reset: `Réinitialiser`,
  my_feedback: `Mes commentaires`,
  feedback_title: `Retour`,
  select_opportunity: `Sélectionnez une opportunité`,
  please_select_opportunity: `Veuillez sélectionner une opportunité`,
  select_report: `Sélectionnez le rapport`,
  please_select_report: `Veuillez sélectionner un rapport`,
  editing_title: `Édition`,
  enabled_title: `Activé`,
  locked_title: `Fermé`,
  content_title_uppercase: `CONTENU`,
  feedback_title_uppercase: `RETOUR`,
  no_data: `Aucune donnée`,
  program_status: `Statut du programme`,
  un_sdgs: `ODD de l'ONU`,
  more_title: `Plus`,
  program_location: `Emplacement du programme`,
  asset_name: `Nom de l'actif`,
  asset_location: `Emplacement des actifs`,
  portfolio_title: `Portefeuille`,
  review_title: `Revoir`,
  payment_date: `Date de paiement`,
  secondary_UN_SDG: `ODD secondaires de l’ONU`,
  summary_title: `Résumé`,
  select_the_programme_you_wish_to_receive: `Sélectionnez le programme pour lequel vous souhaitez recevoir un rapport sur l'actif sélectionné ci-dessus.`,
  manager: `Directeur`,
  add_managers_who_can_invite_reporter: `Ajoutez des responsables qui peuvent inviter des journalistes en votre nom. Remarque : Les utilisateurs internes de votre organisation peuvent être ajoutés à partir de votre`,
  admin_page: `page d'administration`,
  inviting_existing_user: `Inviter un utilisateur existant`,
  invite_new: `Inviter un nouveau`,
  external_users: `utilisateurs externes`,
  by_entering_their_email_address: `en saisissant son adresse email`,
  optional_add_reporters: `Facultatif. Ajoutez des journalistes qui rédigeront des rapports de programme pour vos actifs.`,
  manage_report: `Gérer le rapport`,
  add_asset: `Ajouter un actif`,
  budget_history: `Historique budgétaire`,
  milestones: `Jalons`,
  programme_name_title: `Nom du programme`,
  application: `Application`,
  create: `Créer`,
  comment_title: `Commentaire`,
  cash_donation_saved_successfully: `Don en espèces économisé.`,
  upload_invoice: `Télécharger la facture`,
  upload_title: `Télécharger`,
  confirm_receipt: `Confirmer la réception`,
  received_title: `Reçu`,
  please_confirm_donation_received: `Veuillez confirmer que ce don a bien été reçu.`,
  success_donation_received: `Succès - don reçu`,
  success_invoice_uploaded: `Succès – facture téléchargée`,
  click_to_upload: `Cliquez pour télécharger`,
  settings: `Paramètres`,
  internal_only: `Interne uniquement`,
  visibility_title: `Visibilité`,
  public_title: `Publique`,
  private: `Privé`,
  completed: `Complété`,
  content_package: `Paquet de contenu`,
  please_select_interaction_status: `Veuillez sélectionner le statut de l'interaction.`,
  go_back: `Retourner`,
  budget_dates: `Dates budgétaires`,
  budget_recurring: `Budget récurrent ?`,
  objectives: `Objectifs`,
  supporting_materials: `Matériel de support`,
  web_links: `Liens Internet`,
  administrators: `Administrateurs`,
  application_criteria: `Critères de candidature`,
  documentation_required: `Documentation requise`,
  available_support: `Assistance disponible`,
  none: `Aucun`,
  eligibility_checklist: `Liste de contrôle d'éligibilité`,
  location_supported: `Emplacement pris en charge`,
  project_must_be_within: `Le projet doit être dans`,
  of_this_location: `de cet endroit`,
  expand_all: `Développer tout`,
  entities_supported: `Entités prises en charge`,
  mandatory: `Obligatoire`,
  expected_budget: `Budget prévu`,
  per_opportunity: `Par projet`,
  specific_skills_available: `Compétence spécifique disponible`,
  general_skills_available: `Compétences générales disponibles`,
  any: `N'importe lequel`,
  application_accepted_between: `Candidatures acceptées`,
  donation_to_be_made_between: `Don à faire`,
  interim_update_requested: `Mise à jour intermédiaire demandée`,
  final_report_requested: `Rapport final demandé`,
  show_all_goals: `Afficher tous les objectifs`,
  any_location: `N'importe quel endroit`,
  apply: `Appliquer`,
  eligibility: `Admissibilité`,
  before_applying_please_confirm_your_eligibility: `Avant de postuler, veuillez confirmer votre éligibilité :`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Veuillez confirmer que votre projet est situé dans les emplacements pris en charge ou qu'il profite à ceux qui s'y trouvent.`,
  please_select: `Veuillez sélectionner`,
  project_description: `Description du projet`,
  please_share_a_summary_of_your_project: `Merci de partager un résumé de votre projet`,
  enter_project_summary: `Entrez le résumé du projet`,
  please_describe_your_project: `Veuillez décrire votre projet`,
  for_example_what_do_you_want_to_do: `Par exemple, que voulez-vous faire, comment allez-vous le faire, avez-vous identifié un besoin pour le projet et qui le dirigera ?`,
  this_application_is_to: `Cette candidature consiste à :`,
  application_accepted: `Candidatures acceptées :`,
  application_sections: `Rubriques candidatures`,
  application_preview: `Aperçu de l'application`,
  application_guidance: `Guide de candidature`,
  in_the_application_form: `Dans le formulaire de candidature, il vous sera demandé de partager les détails d'un projet pour lequel vous demandez un financement.`,
  next_title: `'Suivant'`,
  save_n_exit_title: `« Enregistrer et quitter »`,
  submit_title: `'Soumettre'`,
  saves_your_data_and_moves: `enregistre vos données et vous déplace vers l'écran suivant du formulaire de candidature. Vos réponses seront automatiquement enregistrées, sauf si vous rencontrez un problème de connectivité Internet.`,
  saves_your_data_and_closes: `enregistre vos données et ferme le formulaire de candidature, pour que vous puissiez y revenir plus tard. Vous devrez remplir tous les champs obligatoires pour « Enregistrer et quitter » (vous pouvez saisir des valeurs aléatoires, par exemple X comme espace réservé, pour cl`,
  saves_your_data_and_closes_the_report: `enregistre vos données et ferme le rapport, pour que vous puissiez y revenir plus tard. Vous devrez remplir tous les champs obligatoires pour « Enregistrer et quitter » (vous pouvez saisir des valeurs aléatoires, par exemple X comme espace réservé).`,
  sends_your_application_form_to_the_company: `envoie votre dossier de candidature à l'entreprise. Ce bouton apparaît sur l'écran final du formulaire de candidature.`,
  to_access_a_saved_application: `Pour accéder à une application enregistrée : cliquez sur Applications et Action requise.`,
  to_view_a_submitted_application: `Pour afficher une candidature soumise : cliquez sur Candidatures et réponse en attente`,
  start: `Commencer`,
  application_form: `Formulaire de candidature`,
  your_application: `Votre candidature`,
  what_is_the_name_of_your_project: `Quel est le nom de votre projet ?`,
  please_complete_each_screen: `Veuillez remplir chaque écran du formulaire de candidature. Sur le dernier écran, vous verrez un aperçu de votre candidature et à partir de là, vous pourrez cliquer sur « Soumettre » pour l'envoyer à l'entreprise.`,
  project_name: `Nom du projet`,
  add_a_banner_image: `Ajouter une image de bannière`,
  this_will_show_at_the_top_of_your_application_form: `Cela apparaîtra en haut de votre formulaire de candidature rempli.`,
  choose_an_image_from_bizGive: `Choisissez une image sur BizGive`,
  upload_your_own_banner_image: `Téléchargez votre propre image de bannière`,
  additional_images: `Images supplémentaires`,
  bizGive_images: `BizGive Images`,
  where_is_your_project_located: `Où se situe votre projet ?`,
  search_for_and_select_the_address_of_your_location: `Recherchez et sélectionnez l’adresse de votre/vos emplacement(s). Ou bien,`,
  click: `cliquez`,
  any_place_or_point_on_the_map_to_select_it: `n'importe quel endroit ou point sur la carte pour le sélectionner.`,
  add_or_Edit_the_name_for_your_location_and_press: `Ajoutez ou modifiez le nom de votre emplacement et appuyez sur « Ajouter un autre » pour ajouter d'autres emplacements.`,
  add_additional_location: `Ajouter un emplacement supplémentaire`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `Un ou plusieurs emplacements de projet sont situés en dehors de la zone du programme.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Veuillez modifier l'emplacement de votre projet OU expliquer ci-dessous comment votre projet bénéficiera à la zone de programme.`,
  how_will_it_benefit_the_programme_area: `Quels avantages cela apportera-t-il à la zone du programme ?`,
  project_dates: `Dates du projet`,
  when_is_your_project_happening: `Quand se déroule votre projet ?`,
  this_can_be_an_estimate: `Il peut s'agir d'une estimation, car il vous sera demandé de modifier ou de confirmer vos dates si votre candidature est retenue.`,
  projects_must_start_within_12_months: `Les projets doivent démarrer dans les mois de opportuniteStartWithinMonths.`,
  projects_must_not_be_longer_than_6_months: `Les projets ne doivent pas durer plus de mois d’opportunitéLengthMonths.`,
  estimated_start: `Début estimé`,
  estimated_finish: `Finition estimée`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `Y a-t-il une date limite à laquelle vous devez recevoir un don pour que votre projet puisse aller de l'avant ?`,
  if_not_please_leave_this_blank: `Sinon, veuillez laisser ce champ vide.`,
  enter_date: `Entrez la date`,
  what_support_are_you_applying_for: `Pour quelle aide postulez-vous ?`,
  in_kind: `En nature`,
  how_much_are_you_applying_for: `Pour combien postulez-vous ?`,
  enter_amount: `Entrez le montant`,
  how_much_does_your_project_cost_in_total: `Combien coûte votre projet au total ?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Vous demandez un pourcentage du coût total de votre projet`,
  how_will_you_use_any_support_awarded: `Comment utiliserez-vous le soutien accordé ?`,
  enter_number_of_items_or_activity: `Entrez le nombre d'articles ou d'activité`,
  enter_description: `Entrez la description`,
  where_will_additional_funds_come_from: `D’où viendront les fonds supplémentaires ?`,
  internal_resources: `Ressources internes`,
  external_funding: `Financement externe`,
  have_you_already_secured_this_funding: `Avez-vous déjà obtenu ce financement ?`,
  can_your_project_proceed_if_you: `Votre projet peut-il se poursuivre si vous n’obtenez pas ce financement supplémentaire ?`,
  what_outputs_will_the_support_help_you_to_achieve: `Quels résultats le soutien vous aidera-t-il à atteindre ?`,
  your_outputs_will_show_like_this_in_your_application_form: `Vos résultats s'afficheront comme ceci dans votre formulaire de candidature :`,
  what_items_or_services_do_you_need: `De quels articles ou services avez-vous besoin ?`,
  for: `pour`,
  what_volunteering_support_do_you_need: `De quel soutien bénévole avez-vous besoin ?`,
  edit_image: `Modifier l'image`,
  change_image: `Changer l'image`,
  delete_image: `Supprimer l'image`,
  click_delete_to_remove_this_image: `Cliquez sur « Supprimer » pour supprimer cette image.`,
  option: `Option`,
  add: `Ajouter`,
  tips: `Conseils`,
  what_is_an_output: `Qu'est-ce qu'une sortie ?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `Un résultat est ce que vous attendez du soutien accordé. Voici quelques exemples :`,
  number_new_teaching_assistants_trained: `5 nouveaux assistants pédagogiques formés`,
  number_new_teachers_trained: `10 nouveaux enseignants formés`,
  number_workshops_hosted: `3 ateliers animés`,
  number_energy_audits_completed: `4 audits énergétiques réalisés`,
  number_people_more_aware_of_climate_change_in_our_community: `200 personnes plus sensibilisées aux changements climatiques dans notre communauté`,
  number_new_playground_installed: `1 nouvelle aire de jeux installée`,
  please_enter: `Veuillez entrer`,
  which_of_the_company_impact_objectives_will_your_project_support: `Quels objectifs d’impact de l’entreprise votre projet soutiendra-t-il ?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `Quels résultats espérez-vous que votre projet obtiendra ?`,
  what_is_an_outcome: `Qu'est-ce qu'un résultat ?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Un résultat est le changement que vous espérez voir à la suite de votre projet. Voici quelques exemples.`,
  objective_protect_and_improve_the_local_environment: `Objectif : Protéger et améliorer l’environnement local`,
  outcome_improve_fish_populations_through_river_restoration: `Résultat : Améliorer les populations de poissons grâce à la restauration des rivières.`,
  objective_create_and_improve_local_amenities: `Objectif : Créer et améliorer les commodités locales`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Résultat : Améliorer l'efficacité énergétique de la salle des fêtes avec de nouvelles fenêtres.`,
  objective_engage_the_local_community: `Objectif : Engager la communauté locale`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Résultat : Réduire l’isolement et la solitude des personnes âgées.`,
  how_will_you_achieve_these_outcomes: `Comment allez-vous atteindre ces résultats ?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Décrivez brièvement votre approche pour atteindre les résultats.`,
  below_are_some_examples: `Voici quelques exemples :`,
  we_will_remove_excess_silt: `Nous éliminerons l'excès de limon afin de restaurer les zones de reproduction des poissons.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Nous remplacerons nos anciennes fenêtres par des fenêtres à triple vitrage.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Nous organiserons des ateliers hebdomadaires réunissant les personnes âgées.`,
  how_will_you_achieve_this_outcome: `Comment parviendrez-vous à ce résultat ?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `Veuillez ne pas utiliser plus de 25 mots, car il vous sera demandé de décrire votre approche sur l'écran suivant.`,
  enter_outcome: `Entrez le résultat`,
  please_enter_numeric_value: `Veuillez saisir une valeur numérique`,
  expected_decision_date: `Date de décision prévue`,
  beneficiaries: `Bénéficiaires`,
  who_or_what_will_benefit_from_your_project: `À qui ou à quoi bénéficiera votre projet ?`,
  who_are_the_social_beneficiaries: `Qui sont les bénéficiaires sociaux ?`,
  select_beneficiary_type: `Sélectionnez le type de bénéficiaire`,
  how_many_people_will_benefit: `Combien de personnes en bénéficieront ?`,
  direct_beneficiaries: `Bénéficiaires directs`,
  enter_estimated_number: `Entrez le nombre estimé`,
  indirect_beneficiaries: `Bénéficiaires indirects`,
  how_will_the_environment_benefit: `Comment l’environnement en bénéficiera-t-il ?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Par exemple, 10 espèces de nouvelles plantes introduites, 10 ppm de CO2 réduits, 10 animaux terrestres protégés.`,
  select_type_title: `Sélectionnez le type`,
  select_sub_type: `Sélectionnez le sous-type`,
  select_units: `Sélectionnez les unités`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `Vos bénéficiaires environnementaux apparaîtront ainsi dans votre formulaire de candidature :`,
  environmental_beneficiaries: `Bénéficiaires environnementaux`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `Les champs déroulants des bénéficiaires environnementaux vous permettent de partager des détails supplémentaires, par exemple si vous soutenez des espèces, des habitats ou des bâtiments, des plantes ou des animaux et quelles actions vous menez. `,
  select_type_title_head: `Sélectionnez le type :`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Choisissez si votre projet soutient des habitats, tels que des forêts ou des zones boisées, des espèces, telles que des plantes ou des animaux, ou des bâtiments, tels que des écoles ou des bâtiments communautaires partagés, comme une salle des fêtes.`,
  select_sub_type_head: `Sélectionnez le sous-type :`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Choisissez le type d’habitat, d’espèce ou de bâtiment que vous soutenez. Par exemple, sélectionnez l’eau douce si vous soutenez des rivières ou des lacs.`,
  select_action_head: `Sélectionnez une action :`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Choisissez le type d’action que vous entreprenez pour soutenir l’espèce, l’habitat ou le bâtiment. Par exemple, sélectionnez protégé si vous protégez des espèces menacées, restauré si vous régénérez un habitat.`,
  enter_amount_head: `Entrez le montant :`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `Pour les espèces, estimez le nombre de plantes ou d’animaux que vous soutenez dans le cadre de votre projet.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `Pour les habitats, estimez le nombre d’habitats que vous soutenez (nombre) ou la superficie totale (en hectares).`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `Pour les bâtiments, estimez le nombre de bâtiments que vous soutenez (nombre) ou de combien vous réduisez l’énergie, l’eau ou les gaz à effet de serre (Tonnes d’équivalents CO2 (CO2e)).`,
  select_units_head: `Sélectionnez les unités :`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `Le nombre est une estimation du nombre total d’habitats, d’espèces ou de bâtiments que vous envisagez de soutenir.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Les hectares sont une estimation de la superficie totale d’un habitat que vous soutenez.`,
  social_beneficiaries: `Bénéficiaires sociaux`,
  select_the_type_of_beneficiaries_your_project_supports: `Sélectionnez le type de bénéficiaires soutenus par votre projet. Estimez ensuite le nombre total de bénéficiaires que vous envisagez de soutenir, tous types de bénéficiaires confondus.`,
  direct_beneficiaries_head: `Bénéficiaires directs :`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `Le nombre de personnes qui bénéficient directement de votre opportunité.`,
  indirect_beneficiaries_head: `Bénéficiaires indirects :`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `Le nombre de personnes dont les prestations peuvent être attribuées à un bénéficiaire direct.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Par exemple, si votre projet soutient 10 enfants ayant des troubles d'apprentissage, les bénéficiaires directs sont les 10 enfants. Les bénéficiaires indirects sont les familles de ces enfants.`,
  habitats: `Habitats`,
  forest: `Forêt`,
  deserts: `Désert`,
  mountains: `Montagne`,
  coastal: `Côtier`,
  marine: `Marin`,
  freshwater: `Eau douce`,
  polar: `Polaire`,
  wetlands: `Zones humides`,
  rainforest: `Forêt tropicale`,
  arctic: `Arctique`,
  tundra: `Toundra`,
  restored: `Restauré`,
  protected: `Protégé`,
  created: `Créé`,
  hectares: `Hectares`,
  established: `Établi`,
  benefitted: `Bénéficié`,
  terrestrial_animals: `Animaux terrestres`,
  aquatic_animals: `Animaux aquatiques`,
  terrestrial_plants: `Plantes terrestres`,
  aquatic_plants: `Plantes aquatiques`,
  species: `Espèces`,
  select_category: `Sélectionnez la catégorie`,
  select_sub_category: `Sélectionnez une sous-catégorie`,
  please_add_at_least_one_outcome_under_selected_objectives: `Veuillez ajouter au moins 1 résultat sous les objectifs sélectionnés`,
  please_enter_your_approach_for_each_outcome: `Veuillez entrer votre approche pour chaque résultat`,
  create_n_manage_sharing: `Créer et gérer le partage`,
  access_closing_date: `Date de clôture de l'accès`,
  please_choose_closing_date: `Veuillez choisir la date de clôture`,
  newly_invited_users_will_receive_an_email_invitation: `Les utilisateurs nouvellement invités recevront une invitation par e-mail.`,
  existing_invited_users_will_not_be_notified_of_changes: ` Les utilisateurs invités existants ne seront pas informés des modifications.`,
  update: `Mise à jour`,
  user_already_exists: `L'utilisateur existe déjà`,
  verify_your_email: `Vérifiez votre e-mail`,
  please_verify_your_email_to_receive_a_magic_link: `Veuillez vérifier votre adresse e-mail pour recevoir un lien magique pour accéder à votre portail de commentaires.`,
  emissions: `Émissions`,
  greenhouse_gases: `Gaz à effet de serre`,
  reduced: `Réduit`,
  captured: `Capturé`,
  prevented: `Empêché`,
  tonnes_of_CO2_equivalents_C02e: `Tonnes d'équivalent CO2 (C02e)`,
  additional_questions: `Questions supplémentaires`,
  required_documents: `Documents requis`,
  additional_files: `Fichiers supplémentaires`,
  document_name: `Nom du document`,
  custom_question: `Question personnalisée ?`,
  custom_questions: `Questions personnalisées`,
  enter_answer: `Entrez la réponse`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Si vous bénéficiez d'un soutien, vous devrez peut-être partager des mises à jour intermédiaires et un rapport final unique avec l'entreprise. Vous recevrez une notification par e-mail de BizGive si et quand celles-ci sont dues.`,
  can_you_meet_the_required_submission_deadlines: `Pouvez-vous respecter les délais de soumission requis ?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `En fonction des dates estimées de début et de fin de votre projet, veuillez confirmer que vous pourrez respecter les dates limites de soumission ci-dessous. Vous pourrez mettre à jour les dates de votre projet si votre candidature est approuvée.`,
  interim_updates: `Mises à jour intermédiaires`,
  final_report: `Rapport final`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Cette valeur ne peut être inférieure au montant demandé`,
  what_is_an_interim_update: `Qu'est-ce qu'une mise à jour intermédiaire ?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `Une mise à jour demandée par l'entreprise sur l'avancement de votre projet.`,
  download_interim_update_report_template: `Télécharger le modèle de rapport de mise à jour intermédiaire`,
  what_is_a_final_report: `Qu'est-ce qu'un rapport final`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `Un rapport unique exigé par l'entreprise sur ce que votre projet a réalisé avec le soutien apporté.`,
  download_final_report_template: `Télécharger le modèle de rapport final`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `Comment saurai-je quand une mise à jour intermédiaire ou un rapport final est dû ?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Vous recevrez une notification par e-mail de BizGive lorsque la date limite approche. Suivez les instructions contenues dans ces e-mails pour compléter et soumettre ces rapports à l'entreprise.`,
  contact_details: `Coordonnées`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `Après avoir soumis votre candidature, vous recevrez des notifications par e-mail de BizGive sur son statut.`,
  please_add_another_contact_in_case_of_your_absence: `Merci d'ajouter un autre contact en cas d'absence.`,
  if_theyre_already_on_BizGive_select_their_name_below: `S'ils sont déjà sur BizGive, sélectionnez leur nom ci-dessous :`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Invitez un collègue à nous rejoindre en saisissant son adresse e-mail ci-dessous :`,
  select_user: `Sélectionnez un utilisateur`,
  what_is_an_indicator: `Qu'est-ce qu'un indicateur ?`,
  an_indicator_is_a_measure_of_progress: `Un indicateur est une mesure de progrès. Il comprend un objectif et des étapes pour atteindre cet objectif. Par exemple, le nombre de personnes que vous envisagez d’aider et la manière dont ce nombre augmentera au fil du temps.`,
  an_indicator_is_an_estimate: `Un indicateur est une estimation, alors ne vous inquiétez pas si vos plans changent. Si votre candidature est approuvée, il vous sera demandé de mettre à jour vos indicateurs.`,
  indicator_examples: `Exemples d'indicateurs`,
  no_of_people_gaining_a_new_skill_or_qualification: `Nombre de personnes acquérant une nouvelle compétence ou qualification`,
  no_of_workshops_hosted: `Nombre d'ateliers hébergés`,
  decrease_in_local_unemployment: `% de diminution du chômage local`,
  when_do_i_update_my_indicators: `Quand dois-je mettre à jour mes indicateurs ?`,
  if_your_application_is_approved: `Si votre candidature est approuvée, vous recevrez des notifications par e-mail de BizGive lorsque vous devrez mettre à jour vos indicateurs.`,
  how_often_do_I_update_my_indicators: `À quelle fréquence dois-je mettre à jour mes indicateurs ?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Il vous sera demandé de mettre à jour vos indicateurs en même temps que de soumettre votre mise à jour intermédiaire ou votre rapport final.`,
  measuring_progress: `Mesurer les progrès`,
  objective_outcome_specific_indicators: `Indicateurs spécifiques aux objectifs/résultats`,
  mandatory_title: `Obligatoire`,
  about_your_project: `À propos de votre projet`,
  your_request: `Votre demande`,
  planned_impact_title: `Impact prévu`,
  award_criteria: `Critères d'attribution`,
  step_1: `Étape 1`,
  step_2: `Étape 2`,
  step_3: `Étape 3`,
  step_4: `Étape 4`,
  step_5: `Étape 5`,
  submit_your_application: `Soumettez votre candidature`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `Pour soumettre votre candidature, vous devez lire et accepter la candidature`,
  terms_and_conditions: `Termes et conditions`,
  below: `ci-dessous.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Veuillez noter que vous ne pourrez pas modifier votre candidature une fois qu'elle aura été soumise, sauf demande contraire de l'entreprise auprès de laquelle vous postulez.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `En soumettant cette candidature, vous partagerez votre candidature, les détails de l'utilisateur et les informations continues sur le profil de l'entité avec le bailleur de fonds.`,
  enter_caption: `Entrez la légende...`,
  impact_alignment: `Alignement des impacts`,
  approve: `Approuver`,
  decline: `Déclin`,
  requested_support: `Assistance demandée`,
  total_request: `Demande totale`,
  total_project_budget: `Budget total du projet`,
  funder_contribution: `Contribution du bailleur de fonds`,
  planned_expenditure: `Dépenses prévues`,
  additional_funding: `Financement supplémentaire`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Un financement supplémentaire est nécessaire pour couvrir le budget total de l'opportunité.`,
  where_will_additional_funds_be_sourced: `D’où proviendront les fonds supplémentaires ?`,
  has_this_funding_been_secured: `Ce financement a-t-il été assuré ?`,
  can_this_project_go_ahead_without_additional_funding: `Ce projet peut-il aller de l’avant sans financement supplémentaire ?`,
  outputs: `Sorties`,
  you_must_select_yes_to_proceed: `Vous devez sélectionner oui pour continuer`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Veuillez entrer les dates dans les limites mentionnées ci-dessus`,
  at_least_one_checkbox_must_be_selected: `Au moins une case doit être cochée`,
  delete_confirmation: `Confirmation de suppression`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Décocher cette case supprimera toutes les données sous-jacentes que vous avez saisies pour cet objectif ou ce résultat.`,
  at_least_one_outcome_must_be_selected: `Au moins 1 résultat doit être sélectionné`,
  please_select_at_least_one_objective: `Veuillez sélectionner au moins 1 objectif`,
  project_timelines: `Calendrier du projet`,
  project_location: `Emplacement du projet`,
  pending_title: `En attente`,
  view_indicator: `Afficher l'indicateur`,
  indicators_status_confirmation: `Confirmation de l'état des indicateurs`,
  indicators_successfully_submitted: `Indicateurs soumis avec succès`,
  please_create_at_least_indicator_outcome: `Veuillez créer au moins un indicateur par résultat`,
  please_complete_n_delete_pending_indicators: `Veuillez compléter ou supprimer les indicateurs en attente`,
  modal_will_be_closed_after_two_seconds: `Le modal sera fermé après deux secondes`,
  please_enter_indicatorInterimActual: `Veuillez saisir l'indicateurInterimActual`,
  no_comments: `Sans commentaires`,
  enter_final_total: `Entrez le total final`,
  milestone_date: `Date d'étape`,
  accumulative_target: `Objectif cumulatif`,
  actuals: `Actualités`,
  evidence: `Preuve`,
  total_target: `Cible totale`,
  please_enter_total_accumulative_target: `Veuillez saisir l'objectif cumulé total`,
  please_add_value_for_historic_milestone: `Veuillez ajouter une valeur pour chaque étape historique`,
  cancel_uppercase: `ANNULER`,
  submit_uppercase: `SOUMETTRE`,
  press_submit_to_confirm: `Appuyez sur Soumettre pour confirmer votre saisie. Notez que cela sera partagé avec`,
  confirmation: `Confirmation`,
  your_donor_n_can_not_be_edited: `votre donateur et ne peut pas être modifié`,
  indicator_name: `Nom de l'indicateur`,
  please_enter_indicator_name: `Veuillez saisir le nom de l'indicateur`,
  main_focus: `Objectif principal`,
  social_n_beneficiaries: `Social / Bénéficiaires`,
  please_select_beneficiaries: `Veuillez sélectionner les bénéficiaires`,
  please_enter_unit: `Veuillez entrer l'unité`,
  how_will_you_measure_progress: `Comment mesurerez-vous les progrès ?`,
  starting_number_level_indicator: `Numéro/niveau de départ de votre indicateur`,
  if_you_do_not_know_this_then_enter_zero: `Si vous ne le savez pas, entrez 0`,
  target_number_or_level_reach: `Nombre ou niveau cible à atteindre`,
  target_we_aim_to_reach_is: `L’objectif que nous souhaitons atteindre est`,
  from_starting_number_n_level: `à partir du numéro/niveau de départ`,
  estimate_what_change_starting_para: `Facultatif : estimez quel serait le changement dans le nombre/niveau de départ à la fin de la chronologie de votre opportunité si vous n'interveniez pas ?`,
  your_total_effort_will_be: `Votre effort total sera`,
  taking_account_you_did_not_intervene: `en tenant compte de ce qui se passerait si vous n'interveniez pas`,
  how_will_you_gather_evidence: `Comment allez-vous rassembler des preuves ?`,
  please_enter_details: `Veuillez entrer les détails`,
  evidence_verification_method: `Méthode de vérification des preuves`,
  your_contribution: `Votre contribution`,
  measuring_your_impact: `Mesurer votre impact`,
  to_measure_the_progress_of_your_opportunity: `Pour mesurer l'avancement de votre opportunité, l'entreprise vous a demandé d'ajouter des indicateurs. Les indicateurs vous permettent de fixer des objectifs estimés, avec des jalons pour les atteindre.`,
  opportunity_indicators: `Indicateurs d'opportunité`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Ces indicateurs sont généraux pour votre opportunité ou entité. Veuillez cliquer sur « Ajouter » pour les créer.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Ces indicateurs soutiennent les objectifs et les résultats spécifiques de votre opportunité. Veuillez cliquer sur "Ajouter" pour les créer`,
  describe_the_starting_situation: `Décrivez la situation de départ :`,
  describe_the_final_situation: `Décrivez la situation finale cible souhaitée :`,
  describe_the_final_title_situation: `Décrivez la situation finale souhaitée :`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Veuillez confirmer que vous pouvez fournir les éléments de preuve suivants`,
  starting_number_level_of_your_indicator: `Numéro de départ de votre indicateur`,
  target_number_or_level_to_reach: `Nombre cible à atteindre`,
  estimate_what_the_change_in_the_starting_number: `Facultatif : estimez quel serait le changement dans le nombre/niveau de départ à la fin de la chronologie de votre opportunité si vous n'interveniez pas ?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `L'objectif que nous visons à atteindre est le nombre d'employés à partir du numéro/niveau de départ.`,
  your_total_impact_will_be_employed: `Votre impact total sera d'impactNombre d'employés`,
  your_final_absolute_change_is_impactNumber: `Votre dernier changement absolu est impactNumber`,
  your_final_relative_change_is_impactNumber: `Votre dernier changement relatif est impactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Nous viserons un échantillon de 20 personnes...`,
  restrict_applications_to_within_certain_radius_of_this_location: `Restreindre les candidatures à un certain rayon autour de cet emplacement ?`,
  enter_number: `Entrez le numéro`,
  biannually: `Tous les deux ans`,
  please_select_your_impact_strategy: `Veuillez sélectionner votre stratégie d'impact`,
  reporting_requirements: `Exigences de déclaration`,
  starting: `Départ`,
  create_indicator: `Créer un indicateur`,
  optional_title: `Facultatif`,
  optional_head: `Facultatif?`,
  estimate_what_the_level_would_be: `Estimez quel serait le changement du nombre de départ d’ici la date de fin de votre projet si vous n’interveniez pas ? (veuillez ajouter le signe +/-)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Cette valeur ne peut pas être supérieure au montant pour lequel vous postulez`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `Vous devez demander 100 % du coût total du projet`,
  please_save_a_location: `Veuillez enregistrer un emplacement`,
  i_agree: `Je suis d'accord`,
  project_running_dates: `Dates de réalisation des projets`,
  donations_required_before: `Dons requis avant`,
  add_programme: `Ajouter un programme`,
  budget_end_date: `Date de fin du budget`,
  application_window: `Fenêtre d'application`,
  choose_either_option: `Choisissez l'une ou l'autre des options :`,
  copy_an_existing_programme: `Copier un programme existant`,
  create_a_new_programme: `Créer un nouveau programme`,
  what_is_the_name_of_your_programme: `Quel est le nom de votre programme ?`,
  what_is_the_area_of_impact: `Quelle est la zone d’impact ?`,
  projects_or_impact_must_be_within: `Les projets ou l’impact doivent se situer dans :`,
  a_custom_area: `Un espace personnalisé`,
  an_administrative_boundary_eg_a_council_area_or_country: `Une limite administrative, par ex. une commune ou un pays.`,
  a_certain_distance_from_a_point: `Une certaine distance d'un point.`,
  click_on_the_map_to_start_drawing_your_area: `Cliquez sur la carte pour commencer à dessiner votre zone, double-cliquez pour la compléter. Si nécessaire, vous pouvez le supprimer de l'option de nom de zone située sous la carte en cliquant sur l'icône de suppression à côté de la droite du`,
  use_the_search_box_to_find_administrative_boundaries: `Utilisez le champ de recherche pour trouver les limites administratives. Affichez une limite en cliquant sur le nom, sélectionnez une limite en cliquant sur « Choisir ». Supprimez des zones ou modifiez les noms de la section des noms de zone sous le `,
  click_on_the_map_to_add_a_point: `Cliquez sur la carte pour ajouter un point, puis entrez un rayon autorisé ci-dessous et appuyez sur « Générer une zone » pour afficher la zone sur la carte. Recommencez en cliquant sur la carte pour ajouter un nouveau point.`,
  what_is_the_area_called: `Comment s’appelle la zone ?`,
  programme_details: `Détails du programme`,
  write_a_short_summary_of_your_programme: `Rédigez un bref résumé de votre programme`,
  write_a_longer_description: `Écrivez une description plus longue`,
  do_you_wish_to_share_any_supporting_material: `Souhaitez-vous partager du matériel de support ?`,
  select_all_options: `Sélectionnez toutes les options`,
  indicators: `Indicateurs`,
  details: `Détails`,
  programme_support: `Soutien au programme`,
  what_support_can_you_offer: `Quel accompagnement pouvez-vous proposer ?`,
  what_is_your_budget: `Quel est ton budget`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Rendez ce montant budgétaire visible dans votre programme en tant que « Budget estimé »`,
  is_there_a_limit_donation_amount_per_project: `Y a-t-il un montant limite de don par projet ?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `Les projets doivent être entièrement financés par vous sans financement supplémentaire de tiers.`,
  does_this_budget_recur: `Ce budget est-il récurrent ?`,
  per_project: `Par projet`,
  no_it_is_fixed: `Non, c'est réglé.`,
  yes_annual_starting_on: `Oui, annuel à partir du :`,
  please_include_in_your_invoice_the_following_details: `Veuillez inclure dans votre facture les détails suivants...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Partagez toutes les instructions de facturation pour que les bénéficiaires approuvés puissent les consulter`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `Souhaitez-vous télécharger un modèle de facture que les candidats approuvés pourront utiliser ?`,
  what_type_of_volunteering_can_you_offer: `Quel type de volontariat pouvez-vous proposer ?`,
  what_skilled_volunteering_is_available: `Quel bénévolat qualifié est disponible ?`,
  start_date: `Date de début`,
  end_date: `Date de fin`,
  general: `Général`,
  skilled: `Qualifié`,
  skill: `Compétence`,
  number_of_item_service: `Numéro (de l'article/service)`,
  item_service_description: `Description de l'article/du service`,
  what_type_of_in_kind_support_can_you_offer: `Quel type de soutien en nature pouvez-vous offrir ?`,
  timelines: `Chronologies`,
  when_are_you_accepting_applications: `Quand acceptez-vous les candidatures ?`,
  a_date_range: `Une plage de dates`,
  ongoing: `En cours`,
  when_are_application_decisions_made: `Quand les décisions de candidature sont-elles prises ?`,
  periodically: `Périodiquement`,
  when_do_you_expect_to_make_donations: `Quand comptez-vous faire des dons ?`,
  do_you_want_to_restrict_project_timelines: `Voulez-vous restreindre les délais du projet ?`,
  projects_must_start_within: `Les projets doivent démarrer dans`,
  projects_must_not_be_longer_than: `Les projets ne doivent pas durer plus de`,
  months: `mois`,
  eligible_entities: `Entités éligibles`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `Quel type d’entité peut postuler à votre programme ?`,
  please_select_all_that_apply_below: `Veuillez sélectionner tout ce qui s'applique ci-dessous.`,
  uk: `ROYAUME-UNI`,
  international: `International`,
  applicants_must_agree_to_these_before_applying: `Les candidats doivent les accepter avant de postuler`,
  entity_project_must_be: `L'entité/le projet doit être...`,
  application_questions: `Questions de candidature`,
  do_you_want_to_add_any_custom_application_questions: `Souhaitez-vous ajouter des questions d'application personnalisées ?`,
  word_limit: `Limite de mots`,
  question: `Question`,
  please_enter_your_application_terms_and_conditions: `Veuillez saisir les conditions générales de votre candidature`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Nous demandons à tous les candidats d'approuver cela avant de soumettre leur candidature.`,
  please_enter_a_link_to_your_privacy_policy: `Veuillez entrer un lien vers votre politique de confidentialité`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Nous demandons à tous les candidats d'en prendre connaissance avant de soumettre leur candidature.`,
  measuring_impact: `Mesurer l'impact`,
  when_do_you_want_to_receive_interim_updates: `Quand souhaitez-vous recevoir les « Mises à jour intermédiaires » ?`,
  recurring_to_project_dates: `Récurrent aux dates du projet`,
  not_required: `Non requis`,
  every: `Chaque`,
  days_between_project_start_and_end_dates: `Jours entre les dates de début et de fin du projet`,
  when_do_you_want_to_receive_a_final_report: `Quand souhaitez-vous recevoir un « rapport final » ?`,
  relative_to_project_dates: `Par rapport aux dates du projet`,
  days_after_the_project_end_date: `Jours après la date de fin du projet`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `Y a-t-il des questions supplémentaires que vous aimeriez poser dans le rapport final ?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `Souhaitez-vous que les entités acceptent des conditions juridiques supplémentaires lors de la soumission de rapports ?`,
  programme_administration: `Administration du programme`,
  internal_approval_steps: `Étapes d'approbation interne`,
  approval_step: `Étape d'approbation`,
  voting: `Vote`,
  scoring_category: `Catégorie de notation`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Créez les catégories par rapport auxquelles vous souhaitez évaluer les candidatures. « Rapport qualité-prix » ou « Impact total »`,
  insert: `Insérer`,
  scoring_category_options: `Options de catégorie de notation`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Détaillez les options de catégorie disponibles à sélectionner pour les catégories ci-dessus avec la « valeur numérique » de chaque option, afin qu'un score final puisse être calculé. Vous pouvez également éventuellement inclure une description`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Répertoriez les options de catégorie de notation avec une valeur et une description facultative. Par exemple, la valeur pourrait être « 1 » et la description « Faible » ou la valeur « 3 » et la description « Élevée ».`,
  numerical_value: `Valeur numérique`,
  optional_description: `Description facultative`,
  who_will_manage_this_programme: `Qui gérera ce programme ?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `Les responsables peuvent modifier le programme, interagir avec les candidats, approuver les candidatures et recevoir des notifications par e-mail associées.`,
  who_can_view_this_programme: `Qui peut voir ce programme`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Les téléspectateurs peuvent visualiser le programme et les candidatures, mais ne peuvent pas modifier le programme, interagir avec les candidats, approuver les candidatures ni recevoir de notifications par courrier électronique associées.`,
  programme_visibility: `Visibilité du programme`,
  bizGive_open: `BizGive (Ouvert)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Tout organisme de bienfaisance inscrit à BizGive peut consulter votre programme et postuler à celui-ci.`,
  bizGive_invite_only: `BizGive (invitation uniquement)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Seuls les organismes de bienfaisance que vous invitez à postuler à votre programme peuvent le consulter.`,
  public_open: `Public (ouvert)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Votre programme aura son propre lien et une page de destination de marque sur BizGive, vous pourrez donc le partager n'importe où en dehors de la plateforme. Tout organisme de bienfaisance inscrit à BizGive pourra également consulter et postuler.`,
  public_invite_only: `Public (sur invitation uniquement)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Votre programme aura son propre lien et une page de destination de marque sur BizGive, vous pourrez donc le partager n'importe où en dehors de la plateforme. Il ne sera pas visible pour les organisations caritatives inscrites à BizGive, sauf si vous`,
  add_a_custom_programme_url: `Ajouter une URL de programme personnalisée`,
  publish_your_programme: `Publiez votre programme`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Cela rendra votre programme visible selon vos paramètres de visibilité.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Vous pouvez toujours modifier tous les détails des programmes après la publication.`,
  required_document_name: `Nom du document requis`,
  change: `Changement`,
  number_of_days: `Nombre de jours`,
  programme_approval: `Approbation du programme`,
  there_must_be_at_least_1_votingScoreCriteria_added: `Il doit y avoir au moins 1 voteScoreCriteria ajouté`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Il doit y avoir au moins 1 voteCriteriaOptions ajouté`,
  publish: `Publier`,
  confirm: `Confirmer`,
  project_timeline: `Chronologie du projet`,
  company: `Entreprise`,
  this_programme_is_closing_in_number_days: `Ce programme se termine dans quelques jours`,
  this_programme_is_now_closed: `Ce programme est maintenant fermé`,
  the_application_window_is: `La fenêtre de l'application est`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Connectez-vous ou inscrivez-vous à BizGive pour découvrir de nouveaux programmes de financement.`,
  discover_more_programmes: `Découvrez plus de programmes`,
  end: `Fin`,
  to_apply_to_the: `Pour postuler au`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Connectez-vous ou inscrivez-vous pour créer votre compte BizGive gratuit.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Si vous êtes nouveau sur BizGive, créez un profil d'organisation.`,
  complete_your_application_to_the_programme: `Complétez votre candidature au programme.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Recevez des alertes lorsqu'une action est requise ou qu'une décision de financement est prise.`,
  apply_to_other_programmes_from_the_discover_section: `Postulez à d'autres programmes à partir de la section Découvrir.`,
  entity_location: `Emplacement de l'entité`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `Dans quel pays les entités doivent-elles être situées ? Laisser vide si certains sont acceptés`,
  search_country: `Rechercher un pays`,
  please_select_country: `Veuillez sélectionner un pays`,
  your_requested_amount_exceeds_the_programme_limit: `Le montant demandé dépasse la limite du programme`,
  your_requested_amount_is_lower_than_the_programme_limit: `Le montant demandé est inférieur à la limite du programme`,
  your_requested_amount_does_not_equal_the_programme_limit: `Le montant demandé n'est pas égal à la limite du programme`,
  isLocal: `Est local`,
  submission_date: `Date de soumission : `,
  local_within_km: `Local dans la valeur km`,
  group_by_visitor: `Regrouper par visiteur`,
  local_only: `Local uniquement`,
  within_km: `Dans la valeur km`,
  maximum_grant_size: `Taille maximale de la subvention`,
  minimum_grant_size: `Taille minimale de la subvention`,
  none_required: `Aucun requis`,
  outcome_title: `Résultat:`,
  consolidated_report: `Rapport consolidé`,
  portfolio: `Portefeuille`,
  portfolio_name: `Nom du portefeuille`,
  period: `Période`,
  grant_size: `Taille de la subvention`,
  afghanistan: `Afghanistan`,
  albania: `Albanie`,
  algeria: `Algérie`,
  andorra: `Andorre`,
  angola: `Angola`,
  antigua_and_barbuda: `Antigua-et-Barbuda`,
  argentina: `Argentine`,
  armenia: `Arménie`,
  australia: `Australie`,
  austria: `Autriche`,
  azerbaijan: `Azerbaïdjan`,
  bahrain: `Bahreïn`,
  bangladesh: `Bangladesh`,
  barbados: `Barbade`,
  belarus: `Biélorussie`,
  belgium: `Belgique`,
  belize: `Bélize`,
  benin: `Bénin`,
  bhutan: `Bhoutan`,
  bolivia: `Bolivie`,
  bosnia_and_herzegovina: `Bosnie-Herzégovine`,
  botswana: `Botswana`,
  brazil: `Brésil`,
  brunei: `Brunéi`,
  bulgaria: `Bulgarie`,
  burkina_faso: `Burkina Faso`,
  burundi: `Burundi`,
  cambodia: `Cambodge`,
  cameroon: `Cameroun`,
  canada: `Canada`,
  cape_verde: `Cap-Vert`,
  central_african_republic: `République centrafricaine`,
  chad: `Tchad`,
  chile: `Chili`,
  china: `Chine`,
  colombia: `Colombie`,
  comoros: `Comores`,
  congo: `Congo`,
  congo_democratic_republic: `Congo (République démocratique)`,
  costa_rica: `Costa Rica`,
  croatia: `Croatie`,
  cuba: `Cuba`,
  cyprus: `Chypre`,
  czechia: `Tchéquie`,
  denmark: `Danemark`,
  djibouti: `Djibouti`,
  dominica: `Dominique`,
  dominican_republic: `République dominicaine`,
  east_timor: `Timor oriental`,
  ecuador: `Équateur`,
  egypt: `Egypte`,
  el_salvador: `Salvador`,
  equatorial_guinea: `Guinée équatoriale`,
  eritrea: `Érythrée`,
  estonia: `Estonie`,
  eswatini: `Eswatini`,
  ethiopia: `Ethiopie`,
  fiji: `Fidji`,
  finland: `Finlande`,
  france: `France`,
  gabon: `Gabon`,
  georgia: `Géorgie`,
  germany: `Allemagne`,
  ghana: `Ghana`,
  greece: `Grèce`,
  grenada: `Grenade`,
  guatemala: `Guatemala`,
  guinea: `Guinée`,
  guinea_bissau: `Guinée-Bissau`,
  guyana: `Guyane`,
  haiti: `Haïti`,
  honduras: `Honduras`,
  hungary: `Hongrie`,
  iceland: `Islande`,
  india: `Inde`,
  indonesia: `Indonésie`,
  iran: `L'Iran`,
  iraq: `Irak`,
  ireland: `Irlande`,
  israel: `Israël`,
  italy: `Italie`,
  ivory_coast: `Côte d'Ivoire`,
  jamaica: `Jamaïque`,
  japan: `Japon`,
  jordan: `Jordanie`,
  kazakhstan: `Kazakhstan`,
  kenya: `Kenya`,
  kiribati: `Kiribati`,
  kosovo: `Kosovo`,
  kuwait: `Koweit`,
  kyrgyzstan: `Kirghizistan`,
  laos: `Laos`,
  latvia: `Lettonie`,
  lebanon: `Liban`,
  lesotho: `Lesotho`,
  liberia: `Libéria`,
  libya: `Libye`,
  liechtenstein: `Liechtenstein`,
  lithuania: `Lituanie`,
  luxembourg: `Luxembourg`,
  madagascar: `Madagascar`,
  malawi: `Malawi`,
  malaysia: `Malaisie`,
  maldives: `Maldives`,
  mali: `Mali`,
  malta: `Malte`,
  marshall_islands: `Îles Marshall`,
  mauritania: `Mauritanie`,
  mauritius: `Maurice`,
  mexico: `Mexique`,
  federated_states_of_micronesia: `États fédérés de Micronésie`,
  moldova: `Moldavie`,
  monaco: `Monaco`,
  mongolia: `Mongolie`,
  montenegro: `Monténégro`,
  morocco: `Maroc`,
  mozambique: `Mozambique`,
  myanmar_burma: `Myanmar (Birmanie)`,
  namibia: `Namibie`,
  nauru: `Nauru`,
  nepal: `Népal`,
  netherlands: `Pays-Bas`,
  new_zealand: `Nouvelle-Zélande`,
  nicaragua: `Nicaragua`,
  niger: `Niger`,
  nigeria: `Nigeria`,
  north_korea: `Corée du Nord`,
  north_macedonia: `Macédoine du Nord`,
  norway: `Norvège`,
  oman: `Oman`,
  pakistan: `Pakistan`,
  palau: `Palaos`,
  panama: `Panama`,
  papua_new_guinea: `Papouasie-Nouvelle-Guinée`,
  paraguay: `Paraguay`,
  peru: `Pérou`,
  philippines: `Philippines`,
  poland: `Pologne`,
  portugal: `Portugal`,
  qatar: `Qatar`,
  romania: `Roumanie`,
  russia: `Russie`,
  rwanda: `Rwanda`,
  st_kitts_and_nevis: `Saint-Kitts-et-Nevis`,
  st_lucia: `Sainte-Lucie`,
  st_vincent: `Saint-Vincent`,
  samoa: `Samoa`,
  san_marino: `Saint-Marin`,
  sao_tome_and_principe: `Sao Tomé et Principe`,
  saudi_arabia: `Arabie Saoudite`,
  senegal: `Sénégal`,
  serbia: `Serbie`,
  seychelles: `Seychelles`,
  sierra_leone: `Sierra Leone`,
  singapore: `Singapour`,
  slovakia: `Slovaquie`,
  slovenia: `Slovénie`,
  solomon_islands: `Îles Salomon`,
  somalia: `Somalie`,
  south_africa: `Afrique du Sud`,
  south_korea: `Corée du Sud`,
  south_sudan: `Soudan du Sud`,
  spain: `Espagne`,
  sri_lanka: `Sri Lanka`,
  sudan: `Soudan`,
  suriname: `Surinam`,
  sweden: `Suède`,
  switzerland: `Suisse`,
  syria: `Syrie`,
  tajikistan: `Tadjikistan`,
  tanzania: `Tanzanie`,
  thailand: `Thaïlande`,
  the_bahamas: `Les Bahamas`,
  the_gambia: `La Gambie`,
  togo: `Aller`,
  tonga: `Tonga`,
  trinidad_and_tobago: `Trinité-et-Tobago`,
  tunisia: `Tunisie`,
  turkey: `Turquie`,
  turkmenistan: `Turkménistan`,
  tuvalu: `Tuvalu`,
  uganda: `Ouganda`,
  ukraine: `Ukraine`,
  united_arab_emirates: `Émirats arabes unis`,
  united_kingdom: `Royaume-Uni`,
  united_states: `États-Unis`,
  uruguay: `Uruguay`,
  uzbekistan: `Ouzbékistan`,
  vanuatu: `Vanuatu`,
  vatican_city: `Cité du Vatican`,
  venezuela: `Venezuela`,
  vietnam: `Viêt Nam`,
  yemen: `Yémen`,
  zambia: `Zambie`,
  zimbabwe: `Zimbabwe`,
  already_registered: `Déjà inscrit ?`,
  login_here: `Connectez-vous ici`,
  application_to: `Demande à`,
  continue_application: `Continuer la candidature`,
  delete_application: `Supprimer l'application`,
  edit_resubmit: `Modifier et soumettre à nouveau`,
  withdraw: `Retirer`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Cela retirera votre candidature et la ramènera à l’état « En attente ».`,
  this_will_delete_your_application_and_saved_data: `Cela supprimera votre application et vos données enregistrées.`,
  withdraw_application: `Retirer la demande`,
  send: `Envoyer`,
  enable_editing_of_application: `Activer la modification de l'application`,
  application_editing_enabled: `Modification d'application activée`,
  pre_approve: `Pré-approuver`,
  withdraw_pre_approval: `Retirer l'approbation préalable`,
  confirm_approval: `Confirmer l'approbation`,
  grant_award: `Bourse`,
  please_confirm_you_wish_to_approve_this_application: `Veuillez confirmer que vous souhaitez approuver cette demande.`,
  share_a_message: `Partager un message :`,
  confirm_decline: `Confirmer le refus`,
  please_explain_your_decision_to_the_applicant: `Veuillez expliquer votre décision au demandeur`,
  application_related: `Lié à l'application`,
  entity_related: `Lié à l'entité`,
  programme_related: `Lié au programme`,
  add_a_message: `Ajouter un message`,
  there_are_items_we_cannot_fund: `Il y a des articles que nous ne pouvons pas financer`,
  the_impact_of_your_project_is_not_clear_enough: `L'impact de votre projet n'est pas assez clair`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `L'impact de votre projet est moindre par rapport à d'autres applications.`,
  your_entity_does_not_meet_our_criteria: `Votre entité ne répond pas à nos critères`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Votre projet ne correspond pas suffisamment à nos objectifs`,
  other_projects_more_closely_aligned_with_our_objectives: `D'autres projets plus proches de nos objectifs`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Votre projet ne répond pas entièrement à nos critères d'éligibilité`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `Le financement de ce cycle a déjà été décaissé pour des projets similaires`,
  please_select_an_decline_option_or_write_a_message: `Veuillez sélectionner une option de refus ou écrire un message`,
  confirm_pre_approval: `Confirmer la pré-approbation`,
  please_confirm_your_pre_approval: `Veuillez confirmer votre pré-approbation.`,
  please_confirm_your_approval: `Veuillez confirmer votre approbation.`,
  pre_approving_will_not_notify_the_applicant: `L’approbation préalable n’en informera pas le demandeur.`,
  approving_will_not_notify_the_applicant: `L’approbation n’en informera pas le demandeur.`,
  internal_review: `Examen interne`,
  entity_history: `Historique de l'entité`,
  you_have_received_an_application_from_this_entity_before: `Vous avez déjà reçu une candidature de cette entité.`,
  approval: `Approbation`,
  approved_by: `Approuvé par`,
  confirm_step_completion: `Confirmer la fin de l'étape`,
  please_confirm_this_step_has_been_completed: `Veuillez confirmer que cette étape a été effectuée.`,
  total_score: `Note totale`,
  voters: `Électeurs`,
  category_totals: `Totaux des catégories`,
  name: `Nom`,
  telephone: `Téléphone`,
  email: `E-mail`,
  category_score: `Note de catégorie`,
  date: `Date`,
  my_vote: `Mon vote`,
  saved: `Enregistré`,
  vote: `Voter`,
  value_for_money: `Rapport qualité/prix`,
  total_impact: `Impact total`,
  total: `Total`,
  comments: `Commentaires`,
  edit: `Modifier`,
  what_are_your_overall_comments: `Quels sont vos commentaires généraux ?`,
  select_score: `Sélectionnez la partition`,
  please_select_at_least_one_checkbox: `Veuillez cocher au moins une case`,
  create_your_profile: `Créez votre profil`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `Sur les écrans suivants, il vous sera demandé de compléter un profil de votre entité.`,
  how_your_profile_is_used: `Comment votre profil est utilisé`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `Une fois votre profil complet, il sera automatiquement joint à toute candidature que vous soumettez via BizGive.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Les entreprises et BizGive utilisent votre profil pour effectuer des vérifications préalables des antécédents de votre organisation. Il n'est visible que par les entreprises auxquelles vous postulez.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `Une fois terminé, vous pourrez postuler à autant de programmes d’entreprise auxquels vous êtes éligible à partir de l’onglet « Découvrir ».`,
  profile_guidance: `Conseils sur le profil`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `enregistre vos données et vous déplace vers l'écran suivant. Vos réponses seront automatiquement enregistrées, sauf si vous rencontrez un problème de connectivité Internet.`,
  saves_your_data_and_logs_you_out_of_bizGive: `enregistre vos données et vous déconnecte de BizGive. Vous pourrez continuer votre profil lorsque vous vous reconnecterez. Vous devrez remplir tous les champs obligatoires pour « Enregistrer et quitter » (vous pouvez saisir des valeurs aléatoires).`,
  entity_details: `Détails de l'entité`,
  name_n_address: `Nom et adresse`,
  do_you_have_a_different_trading_name_or_display_name: `Avez-vous un nom commercial ou un nom d'affichage différent ?`,
  legal_structure: `Structure juridique`,
  what_is_your_legal_structure: `Quelle est votre structure juridique ?`,
  unregistered_organisation: `Organisation non enregistrée`,
  what_is_your_registration_number: `Quel est votre numéro d'immatriculation ?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Il s'agit de votre numéro d'enregistrement auprès du régulateur compétent de votre entité.`,
  please_share_a_link_to_your_online_registration: `Veuillez partager un lien vers votre inscription en ligne`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Il s’agit d’un lien vers votre profil sur le site Web du régulateur.`,
  please_upload_a_copy_of_your_governing_document: `Veuillez télécharger une copie de vos documents constitutifs`,
  these_are_not_available: `Ceux-ci ne sont pas disponibles`,
  please_share_a_reason: `Veuillez partager une raison`,
  please_upload_a_copy_of_your_governing_documents: `Veuillez télécharger une copie de vos documents constitutifs`,
  for_example_your_trust_deed: `Par exemple, votre acte de fiducie.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Veuillez télécharger une copie de vos comptes annuels les plus récents`,
  for_example_your_Articles_of_association: `Par exemple, vos statuts.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Veuillez télécharger une copie de votre constitution, de votre acte de fiducie ou de vos règles.`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Veuillez télécharger une copie de vos documents d'enregistrement ou de vos comptes annuels les plus récents`,
  entity_types: `Types d'entités`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Enregistré auprès de l’autorité de régulation nationale ou régionale compétente. Par exemple, la Charity Commission au Royaume-Uni.`,
  community_interest_company_uk_only: `Société d'intérêt communautaire (Royaume-Uni uniquement)`,
  registered_with_companies_house: `Enregistré auprès de la Companies House. Forme spéciale de société à responsabilité limitée non caritative qui existe pour bénéficier à une communauté ou poursuivre un objectif social. De nombreuses entreprises sociales sont des CIC.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `Type d'organisme de bienfaisance géré par un petit groupe de personnes appelées administrateurs. Au Royaume-Uni, une fiducie doit s'enregistrer auprès de la Charity Commission lorsque son revenu annuel dépasse 5 000 £.`,
  an_educational_institution_such_as_a_university_or_school: `Un établissement d'enseignement tel qu'une université ou une école.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `Une entité qui n'est ni enregistrée ni réglementée. Par exemple, les clubs, les sociétés et les petits groupes communautaires.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `Un type d'organisation caritative enregistrée en tant que société à responsabilité limitée par garantie ou autre structure d'entreprise à but non lucratif. Au Royaume-Uni, ils sont enregistrés auprès de Companies House en tant que Company Limited par Gu`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Organisations responsables de la fourniture de services publics.`,
  trustees: `Administrateurs`,
  please_provide_the_name_of_your_trustees_or_directors: `Veuillez fournir le nom de vos fiduciaires ou administrateurs.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `Un minimum de 2 est requis. Un seul est requis si vous êtes un CIC britannique.`,
  where_are_you_able_to_run_your_projects: `Où pouvez-vous mener vos projets ?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `En fonction de vos sélections, nous serons en mesure de vous recommander de nouveaux programmes de financement pertinents.`,
  countries_of_operation: `Pays d'opération`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `Dans les pays sélectionnés, pouvez-vous mener des projets à l’échelle nationale ou dans des endroits spécifiques uniquement ?`,
  nationwide: `Dans tout le pays`,
  specific_locations: `Emplacements spécifiques`,
  please_describe_what_your_organisation_does: `Veuillez décrire ce que fait votre organisation`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Veuillez fournir un bref aperçu du but, des buts et des objectifs de votre groupe.`,
  social_media: `Réseaux sociaux`,
  please_share_a_link_to_your_website: `Veuillez partager un lien vers votre site Web`,
  if_applicable_please_share_your_social_media_links: `Le cas échéant, veuillez partager vos liens sur les réseaux sociaux`,
  please_add_your_entity_logo: `Veuillez ajouter le logo de votre entité`,
  please_upload: `Veuillez télécharger`,
  your_profile_is_complete: `Votre profil est complet`,
  you_can: `Tu peux`,
  edit_title_caption: `'Modifier'`,
  your_profile_at_any_point_by_clicking_into: `votre profil à tout moment en cliquant sur « Mon organisation » > « Profil » > « Modifier »`,
  what_happens_next: `Que se passe-t-il ensuite ?`,
  start_your_application: `Démarrez votre candidature`,
  if_you_accessed_bizGive_via_a_company_programme: `Si vous avez accédé à BizGive via un programme d'entreprise, cliquez sur « Appliquer » pour démarrer votre formulaire de candidature.`,
  discover_company_programmes: `Découvrez les programmes de l'entreprise`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Cliquez sur « Découvrir » pour afficher et postuler aux programmes de soutien en direct de l'entreprise.`,
  enter_url: `Entrez l'URL`,
  please_upload_documentation: `Veuillez télécharger la documentation`,
  council_or_government_linked_entity: `Conseil ou entité liée au gouvernement`,
  locations: `Emplacements`,
  specific_locations_within_each_country: `Emplacements spécifiques dans chaque pays`,
  entity_type: `Type d'entité`,
  legal_name: `Nom légal`,
  governing_documents: `Documents constitutifs`,
  operating_location: `Lieu d'exploitation`,
  nationally_in_the_following_countries: `Au niveau national dans les pays suivants :`,
  locally_in_the_following_countries: `Localement dans les pays suivants :`,
  not_available: `Pas disponible`,
  registration_number: `Numéro d'enregistrement`,
  trading_name: `Nom commercial`,
  web_uri: `URI Web`,
  registration_profile_url: `URL du profil d'inscription`,
  discover_funding_opportunities: `Découvrez les opportunités de financement`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Programmes disponibles filtrés par domaine d'activité de votre entité :`,
  change_here: `Changer ici`,
  programme: `Programme`,
  applications_accepted: `Candidatures acceptées`,
  decision_made: `Décision prise`,
  location: `Emplacement`,
  action: `Action`,
  your_entity_type_is_not_supported_by_this_programme: `Votre type d'entité n'est pas pris en charge par ce programme.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Veuillez cliquer sur « OK » et afficher les entités autorisées sur la page d'examen du programme.`,
  content: `Contenu`,
  select_programme: `Sélectionnez le programme`,
  select_report_type: `Sélectionnez le type de rapport`,
  enter_start_date: `Entrez la date de début`,
  enter_end_date: `Entrez la date de fin`,
  report: `Rapport`,
  overdue: `En retard`,
  view_report: `Afficher le rapport`,
  start_report: `Démarrer le rapport`,
  complete_report: `Rapport complet`,
  add_your_profile_picture: `Ajoutez votre photo de profil`,
  project: `Projet`,
  registration_website: `Site d'inscription`,
  outside_of_impact_area: `En dehors de la zone d'impact`,
  this_interim_update_is_for: `Cette mise à jour intermédiaire est destinée`,
  interim_update_deadline: `Date limite de mise à jour intermédiaire`,
  form_guidance: `Guide du formulaire`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `Dans le formulaire, il vous sera demandé de partager les détails du projet pour lequel vous avez reçu un financement.`,
  to_access_a_saved_interim_update_click_into_impact: `Pour accéder à une mise à jour intermédiaire enregistrée : cliquez sur Impact > Contenu > Rapport complet.`,
  to_access_a_saved_interim_update_click_into_impact_content: `Pour afficher une mise à jour intermédiaire soumise : cliquez sur Impact > Contenu > Afficher le rapport.`,
  interim_update: `Mise à jour intermédiaire`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `Vous trouverez ci-dessous l'accompagnement que vous avez demandé à l'entreprise dans votre candidature.`,
  how_have_you_used_the_support_provided_so_far: `Comment avez-vous utilisé le soutien fourni jusqu’à présent ?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `Y a-t-il des changements dans vos dépenses prévues et si oui, pourquoi ?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `Y a-t-il des changements par rapport à votre date d’achèvement estimée et si oui, pourquoi ?`,
  please_email_bizGive: `Veuillez envoyer un e-mail à BizGive`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `s'il y a un changement substantiel dans votre date d'achèvement et nous veillerons à ce que la date limite pour votre rapport final soit mise à jour.`,
  share_images: `Partager des images`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Veuillez télécharger des images pour donner vie à votre projet. Cela augmente considérablement la probabilité que l'entreprise partage votre contenu.`,
  sends_your_form_to_the_company: `envoie votre rapport à l’entreprise. Ce bouton apparaît sur l'écran final du formulaire.`,
  submit_your_report: `Soumettez votre rapport`,
  i_have_read_and_agree_to_the_above_terms: `J'ai lu et j'accepte les conditions ci-dessus.`,
  add_files: `Ajouter des fichiers`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Veuillez confirmer que tous les droits d'auteur et remerciements nécessaires ont été ajoutés.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Je confirme que tous les droits d'auteur et remerciements nécessaires ont été ajoutés.`,
  final_report_deadline: `Date limite du rapport final`,
  please_press_add_to_save_the_invited_user: `Veuillez appuyer sur Ajouter pour enregistrer l'utilisateur invité`,
  inputs: `Entrées`,
  did_any_of_your_plans_change: `L’un de vos projets a-t-il changé ?`,
  please_select_and_enter_your_final_inputs: `Veuillez sélectionner et saisir vos entrées finales`,
  please_update_your_expenditure: `Veuillez mettre à jour vos dépenses`,
  please_update_the_items_or_services_you_used: `Veuillez mettre à jour les articles ou services que vous avez utilisés`,
  please_update_the_volunteering_support_you_used: `Veuillez mettre à jour le support de bénévolat que vous avez utilisé`,
  below_are_the_outputs_you_shared_in_your_application: `Vous trouverez ci-dessous les résultats que vous avez partagés dans votre application.`,
  did_your_outputs_change: `Vos sorties ont-elles changé ?`,
  please_update_your_outputs: `Veuillez mettre à jour vos sorties`,
  your_outputs_will_show_like_this_in_your_report: `Vos résultats s'afficheront comme ceci dans votre rapport :`,
  i_acknowledge_the: `Je reconnais le`,
  below_are_the_beneficiaries_you_shared_in_your_application: `Vous trouverez ci-dessous les bénéficiaires que vous avez partagés dans votre candidature.`,
  did_your_social_beneficiary_types_change: `Vos types de bénéficiaires sociaux ont-ils changé ?`,
  please_update_your_social_beneficiary_types: `Veuillez mettre à jour vos types de bénéficiaires sociaux`,
  did_your_social_beneficiary_numbers_change: `Vos numéros de bénéficiaires sociaux ont-ils changé ?`,
  please_update_your_social_beneficiary_numbers: `Veuillez mettre à jour vos numéros de bénéficiaires sociaux`,
  did_your_environmental_beneficiaries_change: `Vos bénéficiaires environnementaux ont-ils changé ?`,
  please_update_your_environmental_beneficiaries: `Veuillez mettre à jour vos bénéficiaires environnementaux`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `Vous trouverez ci-dessous les objectifs et les résultats que vous avez partagés dans votre candidature.`,
  objectives_n_outcomes: `Objectifs et résultats`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `Avez-vous réussi à atteindre vos objectifs et vos résultats ?`,
  inputs_n_outputs: `Entrées et sorties`,
  case_studies: `Études de cas`,
  preview_n_submit: `Aperçu et soumission`,
  impact_measures: `Mesures d'impact`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `L'entreprise vous a demandé d'ajouter des indicateurs pour mesurer l'avancement de votre projet.`,
  general_indicators: `Indicateurs généraux`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Ces indicateurs sont généraux pour votre opportunité ou entité. Veuillez cliquer sur « Ajouter » pour les créer.`,
  indicator: `Indicateur`,
  required: `Requis?`,
  target: `Cible`,
  final_title: `Final`,
  status: `Statut`,
  project_indicators: `Indicateurs du projet`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Les indicateurs ci-dessous sont liés aux objectifs et résultats que vous avez sélectionnés. Veuillez cliquer sur « Ajouter » pour les créer.`,
  objective: `Objectif`,
  outcome: `Résultat`,
  achieved: `Réalisé`,
  your_absolute_impact_is: `Votre impact absolu est impactNumber`,
  your_relative_impact_is: `Votre impact relatif est impactNumber`,
  case_studies_and_media: `Études de cas et médias`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Les études de cas et les images augmentent la probabilité que l'entreprise partage votre projet. Dans la mesure du possible, veuillez partager une étude de cas et au moins une image.`,
  add_case_study: `Ajouter une étude de cas`,
  add_images: `Ajouter des images`,
  please_upload_this_file_type_in_the_add_files_section_below: `Veuillez télécharger ce type de fichier dans la section Ajouter des fichiers ci-dessous`,
  please_upload_images_in_the_additional_images_section_above: `Veuillez télécharger des images dans la section « Images supplémentaires » ci-dessus`,
  upload_any_image_files_here_png_jpg: `Téléchargez tous les fichiers image ici, par ex. .png, .jpg`,
  upload_any_documents_that_you_wish_to_share: `Téléchargez tous les documents que vous souhaitez partager, par ex. .doc, .pdf ou .xlsx`,
  case_study_name: `Nom de l'étude de cas`,
  what_impact_did_your_project_have: `Quel impact votre projet a-t-il eu ?`,
  add_a_description: `Ajouter une description`,
  for_example_what_was_there_at_start_what_did_you_do_and_what_was_the_result: `Par exemple : qu’y avait-il au départ, qu’avez-vous fait et quel a été le résultat ?`,
  share_a_quote_such_as_from_a_beneficiary: `Partager un devis, par exemple celui d'un bénéficiaire`,
  quote_by: `Citation par`,
  please_share_any_images: `Veuillez partager des images`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `Que se passe-t-il ensuite ? Envisagez-vous par exemple de développer davantage votre projet ?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Si vous souhaitez partager autre chose avec l'entreprise, veuillez utiliser la case ci-dessous`,
  the_company_has_requested_some_additional_information: `L'entreprise a demandé des informations supplémentaires.`,
  content_agreement: `Accord de contenu`,
  view_agreement: `Voir l'accord`,
  application_agreement: `Accord d'application`,
  send_message: `Envoyer un message`,
  this_final_Report_is_for: `Ce rapport final est destiné`,
  company_questions: `Questions sur l'entreprise`,
  next_steps: `Prochaines étapes`,
  additional_details: `Détails supplémentaires`,
  objectives_and_outcomes: `Objectifs et résultats`,
  planned: `Prévu`,
  actual: `Réel`,
  days: `Jours`,
  of_equivalent_value: `de valeur équivalente`,
  case_study: `Étude de cas`,
  includes_changes: `Inclut les modifications`,
  hundred_as_planned: `100% comme prévu`,
  show_planned_efforts: `Afficher les efforts planifiés`,
  final: `Final`,
  support_awarded: `Soutien accordé`,
  password_reset_expired: `Réinitialisation du mot de passe expiré`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Veuillez sélectionner à nouveau « Mot de passe oublié » et cliquez sur l'e-mail pour réinitialiser votre mot de passe dans les 15 minutes.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Veuillez vérifier votre dossier spam si l'e-mail n'est pas immédiatement visible.`,
  request: `Demande`,
  please_note_this_email_address_needs_to_match_the_address: `Attention : cette adresse e-mail doit correspondre à l'adresse à laquelle vous avez reçu votre invitation.`,
  an_access_email_has_sent_to: `Un email d'accès a été envoyé à :`,
  you_can_close_this_tab: `Vous pouvez fermer cet onglet.`,
  we_couldnt_find_your_email_address: `Nous n'avons pas trouvé votre adresse e-mail. Veuillez vous assurer qu'il s'agit du même e-mail que votre e-mail d'invitation.`,
  the_feedback_portal_link_has_now_expired: `Le lien du portail de commentaires a maintenant expiré.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Veuillez contacter l'administrateur de votre programme si vous avez toujours besoin d'un accès.`,
  verify: `Vérifier`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `L'adresse e-mail saisie ne correspond pas à votre lien unique. Veuillez vous assurer qu'il s'agit du même e-mail que votre e-mail d'invitation.`,
  email_entered: `E-mail saisi`,
  try_again: `Essayer à nouveau`,
  welcome_to_your_voting_panel: `Bienvenue sur votre panel de vote !`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Veuillez cliquer sur « Examiner » pour évaluer chaque candidature, puis voter.`,
  please_enter_your_name: `Veuillez entrer votre nom`,
  registered_charity: `Organisme de bienfaisance enregistré`,
  charitable_company: `Entreprise caritative`,
  community_interest_company: `Entreprise d’Intérêt Communautaire`,
  charitable_trust: `Fiducie caritative`,
  for_profit_company: `Entreprise à but lucratif`,
  academic_institution: `Établissement universitaire`,
  government_linked_entity: `Entité liée au gouvernement`,
  parish_or_community_council: `Conseil paroissial ou communautaire`,
  please_upload_a_copy_of_your_governing_document1: `Veuillez télécharger une copie de votre document constitutif`,
  please_upload_a_copy_of_your_governing_document2: `Veuillez télécharger une copie de votre document constitutif`,
  please_upload_a_copy_of_your_governing_document4: `Veuillez télécharger une copie de votre document constitutif`,
  insert_number: `Insérer le numéro`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Donnez vie au projet. Partagez des photos de ce que vous allez changer ou prévoyez de réaliser.`,
  please_select_an_existing_user_or_invite_a_new_one: `Veuillez sélectionner un utilisateur existant ou en inviter un nouveau.`,
  decisions_to_be_made: `Décisions à prendre :`,
  please_add_at_least_one_criteria: `Veuillez ajouter au moins un critère`,
  see_full_report: `Voir le rapport complet`,
  internal_actions: `Actions internes`,
  country_af: `Afghanistan`,
  country_ax: `Îles Åland`,
  country_al: `Albanie`,
  country_dz: `Algérie`,
  country_as: `Samoa américaines`,
  country_ad: `Andorre`,
  country_ao: `Angola`,
  country_ai: `Anguilla`,
  country_aq: `Antarctique`,
  country_ag: `Antigua-et-Barbuda`,
  country_ar: `Argentine`,
  country_am: `Arménie`,
  country_aw: `Aruba`,
  country_au: `Australie`,
  country_at: `Autriche`,
  country_az: `Azerbaïdjan`,
  country_bs: `Bahamas`,
  country_bh: `Bahreïn`,
  country_bd: `Bangladesh`,
  country_bb: `Barbade`,
  country_by: `Biélorussie`,
  country_be: `Belgique`,
  country_bz: `Bélize`,
  country_bj: `Bénin`,
  country_bm: `Bermudes`,
  country_bt: `Bhoutan`,
  country_bo: `Bolivie, État plurinational de`,
  country_bq: `Bonaire, Saint-Eustache et Saba`,
  country_ba: `Bosnie-Herzégovine`,
  country_bw: `Botswana`,
  country_bv: `Île Bouvet`,
  country_br: `Brésil`,
  country_io: `Territoire britannique de l'océan Indien`,
  country_bn: `Brunéi Darussalam`,
  country_bg: `Bulgarie`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Cap-Vert`,
  country_kh: `Cambodge`,
  country_cm: `Cameroun`,
  country_ca: `Canada`,
  country_ky: `Îles Caïmans`,
  country_cf: `République centrafricaine`,
  country_td: `Tchad`,
  country_cl: `Chili`,
  country_cn: `Chine`,
  country_cx: `Île Christmas`,
  country_cc: `Îles Cocos (Keeling)`,
  country_co: `Colombie`,
  country_km: `Comores`,
  country_cg: `Congo`,
  country_cd: `Congo, République démocratique du`,
  country_ck: `Îles Cook`,
  country_cr: `Costa Rica`,
  country_ci: `Côte d'Ivoire`,
  country_hr: `Croatie`,
  country_cu: `Cuba`,
  country_cw: `Curaçao`,
  country_cy: `Chypre`,
  country_cz: `Tchéquie`,
  country_dk: `Danemark`,
  country_dj: `Djibouti`,
  country_dm: `Dominique`,
  country_do: `République dominicaine`,
  country_ec: `Équateur`,
  country_eg: `Egypte`,
  country_sv: `Salvador`,
  country_gq: `Guinée équatoriale`,
  country_er: `Érythrée`,
  country_ee: `Estonie`,
  country_sz: `Eswatini`,
  country_et: `Ethiopie`,
  country_fk: `Îles Falkland (Malvinas)`,
  country_fo: `Îles Féroé`,
  country_fj: `Fidji`,
  country_fi: `Finlande`,
  country_fr: `France`,
  country_gf: `Guyane française`,
  country_pf: `Polynésie française`,
  country_tf: `Terres australes françaises`,
  country_ga: `Gabon`,
  country_gm: `Gambie`,
  country_ge: `Géorgie`,
  country_de: `Allemagne`,
  country_gh: `Ghana`,
  country_gi: `Gibraltar`,
  country_gr: `Grèce`,
  country_gl: `Groenland`,
  country_gd: `Grenade`,
  country_gp: `Guadeloupe`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernesey`,
  country_gn: `Guinée`,
  country_gw: `Guinée-Bissau`,
  country_gy: `Guyane`,
  country_ht: `Haïti`,
  country_hm: `Île Heard et îles McDonald`,
  country_va: `Saint-Siège`,
  country_hn: `Honduras`,
  country_hk: `Hong Kong`,
  country_hu: `Hongrie`,
  country_is: `Islande`,
  country_in: `Inde`,
  country_id: `Indonésie`,
  country_ir: `Iran, République islamique d'`,
  country_iq: `Irak`,
  country_ie: `Irlande`,
  country_im: `Île de Man`,
  country_il: `Israël`,
  country_it: `Italie`,
  country_jm: `Jamaïque`,
  country_jp: `Japon`,
  country_je: `Jersey`,
  country_jo: `Jordanie`,
  country_kz: `Kazakhstan`,
  country_ke: `Kenya`,
  country_ki: `Kiribati`,
  country_kp: `Corée, République populaire démocratique de`,
  country_kr: `Corée, République de`,
  country_kw: `Koweit`,
  country_kg: `Kirghizistan`,
  country_la: `République démocratique populaire lao`,
  country_lv: `Lettonie`,
  country_lb: `Liban`,
  country_ls: `Lesotho`,
  country_lr: `Libéria`,
  country_ly: `Libye`,
  country_li: `Liechtenstein`,
  country_lt: `Lituanie`,
  country_lu: `Luxembourg`,
  country_mo: `Macao`,
  country_mg: `Madagascar`,
  country_mw: `Malawi`,
  country_my: `Malaisie`,
  country_mv: `Maldives`,
  country_ml: `Mali`,
  country_mt: `Malte`,
  country_mh: `Îles Marshall`,
  country_mq: `Martinique`,
  country_mr: `Mauritanie`,
  country_mu: `Maurice`,
  country_yt: `Mayotte`,
  country_mx: `Mexique`,
  country_fm: `Micronésie, États fédérés de`,
  country_md: `Moldavie, République de`,
  country_mc: `Monaco`,
  country_mn: `Mongolie`,
  country_me: `Monténégro`,
  country_ms: `Montserrat`,
  country_ma: `Maroc`,
  country_mz: `Mozambique`,
  country_mm: `Birmanie`,
  country_na: `Namibie`,
  country_nr: `Nauru`,
  country_np: `Népal`,
  country_nl: `Pays-Bas, Royaume des`,
  country_nc: `Nouvelle-Calédonie`,
  country_nz: `Nouvelle-Zélande`,
  country_ni: `Nicaragua`,
  country_ne: `Niger`,
  country_ng: `Nigeria`,
  country_nu: `Nioué`,
  country_nf: `Île Norfolk`,
  country_mk: `Macédoine du Nord`,
  country_mp: `Îles Mariannes du Nord`,
  country_no: `Norvège`,
  country_om: `Oman`,
  country_pk: `Pakistan`,
  country_pw: `Palaos`,
  country_ps: `Palestine, État de`,
  country_pa: `Panama`,
  country_pg: `Papouasie-Nouvelle-Guinée`,
  country_py: `Paraguay`,
  country_pe: `Pérou`,
  country_ph: `Philippines`,
  country_pn: `Pitcairn`,
  country_pl: `Pologne`,
  country_pt: `Portugal`,
  country_pr: `Porto Rico`,
  country_qa: `Qatar`,
  country_re: `Réunion`,
  country_ro: `Roumanie`,
  country_ru: `Fédération de Russie`,
  country_rw: `Rwanda`,
  country_bl: `Saint Barthélemy`,
  country_sh: `Sainte-Hélène, Ascension et Tristan da Cunha`,
  country_kn: `Saint-Kitts-et-Nevis`,
  country_lc: `Sainte-Lucie`,
  country_mf: `Saint-Martin (partie française)`,
  country_pm: `Saint-Pierre-et-Miquelon`,
  country_vc: `Saint-Vincent-et-les Grenadines`,
  country_ws: `Samoa`,
  country_sm: `Saint-Marin`,
  country_st: `Sao Tomé et Principe`,
  country_sa: `Arabie Saoudite`,
  country_sn: `Sénégal`,
  country_rs: `Serbie`,
  country_sc: `Seychelles`,
  country_sl: `Sierra Leone`,
  country_sg: `Singapour`,
  country_sx: `Sint Maarten (partie néerlandaise)`,
  country_sk: `Slovaquie`,
  country_si: `Slovénie`,
  country_sb: `Îles Salomon`,
  country_so: `Somalie`,
  country_za: `Afrique du Sud`,
  country_gs: `Géorgie du Sud et îles Sandwich du Sud`,
  country_ss: `Soudan du Sud`,
  country_es: `Espagne`,
  country_lk: `Sri Lanka`,
  country_sd: `Soudan`,
  country_sr: `Surinam`,
  country_sj: `Svalbard et Jan Mayen`,
  country_se: `Suède`,
  country_ch: `Suisse`,
  country_sy: `République arabe syrienne`,
  country_tw: `Taïwan, province de Chine`,
  country_tj: `Tadjikistan`,
  country_tz: `Tanzanie, République-Unie de`,
  country_th: `Thaïlande`,
  country_tl: `Timor-Leste`,
  country_tg: `Aller`,
  country_tk: `Tokélaou`,
  country_to: `Tonga`,
  country_tt: `Trinité-et-Tobago`,
  country_tn: `Tunisie`,
  country_tr: `Turquie`,
  country_tm: `Turkménistan`,
  country_tc: `Îles Turques et Caïques`,
  country_tv: `Tuvalu`,
  country_ug: `Ouganda`,
  country_ua: `Ukraine`,
  country_ae: `Émirats arabes unis`,
  country_gb: `Royaume-Uni de Grande-Bretagne et d'Irlande du Nord`,
  country_us: `les états-unis d'Amérique`,
  country_um: `Îles mineures éloignées des États-Unis`,
  country_uy: `Uruguay`,
  country_uz: `Ouzbékistan`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, République bolivarienne du`,
  country_vn: `Viet Nam`,
  country_vg: `Îles Vierges (britanniques)`,
  country_vi: `Îles Vierges (États-Unis)`,
  country_wf: `Wallis et Futuna`,
  country_eh: `Sahara occidental`,
  country_ye: `Yémen`,
  country_zm: `Zambie`,
  country_zw: `Zimbabwe`
  }

export default frLocale;
